<script>
import flatPickr from "vue-flatpickr-component";
import moment from "moment";
import "flatpickr/dist/flatpickr.css";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../app.config";
import Swal from "sweetalert2";
import Lottie from "@/components/widgets/lottie.vue";
import animationData from "@/components/widgets/msoeawqm.json";
import axios from "axios";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.scss";
import Slider from "@vueform/slider";
import "@vueform/slider/themes/default.css";

import loader from "../../components/widgets/loader";

// components
import notes from '../../components/users/notes';
import messages from '../../views/widgets/messages';
import econtacts from '../../components/clients/econtacts';
import TrafficLightLegend from "../../components/TrafficLightLegend.vue";
// import PlaidAuthVerifyModal from "../../components/PlaidAuthVerifyModal.vue";
import { ref, watch } from "vue";
import useVuelidate from "@vuelidate/core";
import jwt_decode from "jwt-decode";
import SimpleTypeahead from "vue3-simple-typeahead";
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'; // Optional default CSS
import { Upload } from '@progress/kendo-vue-upload';
import '@progress/kendo-theme-default/dist/all.css';
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { GoogleMap, Marker, MarkerCluster, InfoWindow } from "vue3-google-map";
import ClickToCallButton from "@/components/ClickToCallButton.vue";

export default {
  page: {
    title: "Clients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    ClickToCallButton,
    flatPickr,
    Multiselect,
    Lottie,
    notes,
    messages,
    SimpleTypeahead,
    Upload,
    econtacts,
    loader,
    GoogleMap,
    Marker,
    MarkerCluster,
    InfoWindow,
    TrafficLightLegend,
    // PlaidAuthVerifyModal,
    Slider
  },
  data() {
    return {
      title: "Client List",
      items: [
        { text: "Clients", href: "/" },
        { text: "Client List", active: true },
      ],

      // ✅ IMPORTANT: keep ONLY one selectedClients key
      selectedClients: [],
      selectedClientObjects: [],
      selectedTransferAgentId: null,

      // Counters used in addBeneficiary/addEcontact/addAdditaments
      beneficiaryQty: 0,
      eContactQty: 0,
      additamentsQty: 0,

      openCreate: 0,
      page: 1,
      perPage: 100,
      pages: [],
      errors: [],
      searchQuery: null,
      timeConfig: {
        enableTime: false,
        dateFormat: "d M, Y"
      },
      dateTimeConfig: {
        enableTime: true,
        dateFormat: "F j, Y H:i K"
      },
      humanfriendlyConfig: {
        dateFormat: "F j, Y",
      },
      typeList: {},
      clientData: {
        ID: null,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        address: '',
        postalCode: '',
        city: '',
        state: '',
        country: 'USA',
        gender: '',
        language: '',
        status: '',
        leadType: '',
        type: '',
        policyNumber: '',
        departmentID: '',
        birthday: '',
        interview: '',
        agentNumber: '',
        createdBy: '',
        markerColor: null,
        lastVisitDate: null,
        donotcall: 0,
        age: '',
        age_source: '',
        note: ''
      },
      modalFormTitle: 'Edit Client',

      data: {
        token: localStorage.getItem('jwt'),
        searchValues: {
          type: [],
          noteSearch: '',
          keyword: '',
          language: '3',
          clients: 1,
          status: [],
          sortBy: 'name',
          orderBy: 'ASC',
          dateRange: '0',
          department: '0',
          toDate: new Date().toLocaleDateString('en-us', { year: "numeric", month: "long", day: "numeric" }),
          fromDate: new Date(new Date().setFullYear(new Date().getFullYear() - 5)).toLocaleDateString('en-us', { year: "numeric", month: "long", day: "numeric" }),
          dncFilter: 'exclude',
          age: [0, 100]
        },
      },
      defaultOptions: { animationData: animationData },
      list: [],
      listQty: 0,

      agentData: {
        username: '',
        email: '',
        firstName: '',
        lastName: '',
        language: '',
        status: '',
        phone: '',
        department: '',
        state: '',
        birthDate: '',
        address: '',
        country: 'USA',
        zipCode: '',
        interview: '',
        agentNumber: '',
        createdBy: '',
        insuranceLicense: '',
        licenseNumber: ''
      },
      departmentList: {},
      statusList: {},
      prospectStatusList: {},
      notesData: [],
      messagesData: [],
      file: [],
      content: [],
      parsed: false,
      itemsSearch: [],
      spectedColumnsClients: [
        "Last Name",
        "First Name",
        "Address",
        "City",
        "State",
        "Zip",
        "Daytime Phone",
        "Evening Phone",
        "Age",
        "Media",
        "Language",
        "Received",
        "Assigned",
        "Second Pre-Approach Letter"
      ],
      agentVisible: true,
      idNumber: 1,
      preview: null,
      image: null,
      preview_list: [],
      image_list: [],
      uploadFiles: [],
      // Enhanced upload wizard
      uploadStep: 1, // 1: Upload, 2: Map Columns, 3: Review
      uploadedFile: null,
      parsedHeaders: [],
      parsedData: [],
      columnMapping: {},
      systemFields: [
        { key: 'fullName', label: 'Full Name (will split)', required: false, isSplittable: true },
        { key: 'First Name', label: 'First Name *', required: true },
        { key: 'Last Name', label: 'Last Name *', required: true },
        { key: 'Email', label: 'Email', required: false },
        { key: 'Address', label: 'Address', required: false },
        { key: 'City', label: 'City', required: false },
        { key: 'State', label: 'State', required: false },
        { key: 'Zip', label: 'ZIP Code', required: false },
        { key: 'Evening Phone', label: 'Phone number *', required: true },
        { key: 'Daytime Phone', label: 'Daytime Phone', required: false },
        { key: 'Age', label: 'Age', required: false },
        { key: 'Media', label: 'Media', required: false },
        { key: 'language', label: 'Language (from file)', required: false },
        { key: 'note', label: 'Comment / Note', required: false },
      ],
      validationErrors: [],
      crmSelectedUser: localStorage.getItem('selectedUser'),
      crmUserID: localStorage.getItem('id'),
      fileList: [],
      eContactlist: [],
      previewImageURL: '',
      mobileView: true,
      isLoading: false,
      phoneVerification: '',

      // — Map Modal —
      showMapModal: false,
      mapMarkers: [],
      selectedMapMarker: null,
      mapIsLoading: false,
    }
  },

  watch: {
    // OJO: en tu código original esto estaba como companies(), pero companies no existe
    // Si quieres recalcular páginas cuando cambie la cantidad total:
    listQty() {
      this.setPages();
    },
  },

  created() {
    this.setPages();
  },

  filters: {
    trimWords(value) {
      return value.split(" ").splice(0, 20).join(" ") + "...";
    },
  },

  methods: {
    // ✅ You referenced this in SimpleTypeahead but didn't define it
    selectItemEventHandler(item) {
      // Aquí puedes guardar el agente seleccionado si lo necesitas.
      // Por ahora lo dejo sin romper la app.
      // console.log("Selected agent:", item);
      return item;
    },

    editdata(data) {
      document.getElementById('id').value = data.id
      document.getElementById('customername').value = data.name;
      document.getElementById('companyname').value = data.company;
      document.getElementById('leadsscore').value = data.score;
      document.getElementById('phone').value = data.phone;
      document.getElementById('location').value = data.location;
      document.getElementById('date').value = data.date;
    },

    addNewAgentModal() {
      this.openCreate = 1;
      this.resetAgentData();
      this.crmSelectedUser = null;
      this.modalFormTitle = "Add Client";
      document.getElementById("addform").reset();
      document.getElementById('add-btn').style.display = 'block';
      document.getElementById('edit-btn').style.display = 'none';
      document.getElementById("addform").reset();
    },

    async checkClientExists() {
      const data = {
        token: localStorage.getItem('jwt'),
        isProspect: 0,
        userEmail: localStorage.getItem('email'),
        clientID: localStorage.getItem('selectedUser'),
        userID: localStorage.getItem('id'),
        potentialClientEmail: this.clientData.email
      }

      if (this.validEmail(data.potentialClientEmail)) {
        await axios
            .post('/api/client/emailExists', data)
            .then(response => {
              let div = document.querySelector(".createEmail");

              if (response.data > 0) {
                div.classList.add("is-invalid");
              } else {
                div.classList.remove("is-invalid");
              }
            })
            .catch(error => {
              if (error.response) {
                Swal.fire("Oops!", "Please, contact your SysAdmin.", "error");
              }
            })
      }
    },

    async updateClient() {
      this.errors = []

      if (!this.clientData.lastName) this.errors.push('Last Name is required.');
      if (!this.clientData.gender) this.errors.push('Gender is required.');
      if (!this.clientData.language) this.errors.push('Language is required.');
      if (!this.clientData.status) this.errors.push('Status is required.');
      if (!this.clientData.phoneNumber) this.errors.push('Phone is required.');
      if (this.validPhone(this.clientData.phoneNumber) === false && this.clientData.phoneNumber !== '') {
        this.errors.push('Please, write a valid phone number!');
      }
      if (!this.clientData.departmentID) this.errors.push('Department is required.');

      if (!this.errors.length) {
        const data = {
          username: '',
          email: this.clientData.email,
          city: this.clientData.city,
          firstName: this.clientData.firstName,
          lastName: this.clientData.lastName,
          language: this.clientData.language,
          status: this.clientData.status,
          leadType: this.clientData.leadType,
          gender: this.clientData.gender,
          phoneNumber: this.clientData.phoneNumber,
          departmentID: this.clientData.departmentID,
          policyNumber: this.clientData.policyNumber,
          state: this.clientData.state,
          birthDate: this.formatDate(this.clientData.birthday, 'DD MMM, YYYY'),
          address: this.clientData.address,
          country: this.clientData.country,
          postalCode: this.clientData.postalCode,
          interviewDate: this.clientData.interview,
          createdBy: localStorage.getItem('email'),
          licenseNumber: this.clientData.licenseNumber,
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id'),
          clientID: localStorage.getItem('selectedUser')
        }

        await axios
            .put('/api/client/updateClient', data)
            .then(async response => {
              if (response) {
                document.getElementById('close-modal').click();
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Client update successfully!'
                });
              }
            })
            .catch(async error => {
              if (error.response) {
                if (error.response.data.detail === 'Your session is expired!') {
                  this.$router.push('logout')
                }

                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },

    isDate(txt) {
      var matches = txt.match(/^\d?\d\/(\d?\d)\/\d{4}$/);
      return !!matches && !!Date.parse(txt) && new Date(txt).getDate() == matches[1];
    },

    async createClient() {
      this.errors = []

      if (!this.clientData.firstName) this.errors.push('First Name is required.');
      if (!this.clientData.lastName) this.errors.push('Last Name is required.');
      if (!this.clientData.status) this.errors.push('Status is required.');
      if (!this.clientData.phoneNumber) this.errors.push('Phone is required.');

      // NOTE: this check in your original code uses this.clientData.phone (not phoneNumber)
      // I left your logic but it's likely a bug in your code.
      if (this.validPhone(this.clientData.phone) === false && this.clientData.phone === '') {
        this.errors.push('Please, write a valid phone number!');
      }

      if (!this.clientData.departmentID) this.errors.push('Department is required.');
      if (this.clientData.type === 'undefined') this.errors.push('Lead/Client Source is required.');
      if (this.clientData.gender !== 'M' && this.clientData.gender !== 'F') this.errors.push('Gender is required.');
      if (this.clientData.language !== '1' && this.clientData.language !== '2') this.errors.push('Language is required.');
      if (this.clientData.leadType === 'undefined') this.errors.push('Lead/client Source is required.');

      if (this.clientData.birthday === undefined || this.clientData.birthday === null) {
        this.errors.push('Birthdate is required.');
      }

      if (!this.errors.length) {
        let beneficiaries = this.getBenficiaries();
        let emergencyContacts = this.getEmergency();
        let addedChilds = this.getAddedChilds();
        let note = { 'note': this.clientData.note };

        let formValues = {
          'address': this.clientData.address,
          'birthday': this.clientData.birthday,
          'city': this.clientData.city,
          'country': this.clientData.country,
          'department': this.clientData.departmentID,
          'email': this.clientData.email,
          'firstName': this.clientData.firstName,
          'interview': this.clientData.interview,
          'language': this.clientData.language,
          'lastName': this.clientData.lastName,
          'leadType': this.clientData.leadType,
          'note': this.clientData.note,
          'phoneNumber': this.clientData.phoneNumber,
          'policyNumber': this.clientData.policyNumber,
          'postalCode': this.clientData.postalCode,
          'state': this.clientData.state,
          'status': this.clientData.status,
          'length': this.clientData.length,
          'gender': this.clientData.gender
        };

        let values = { 0: { formValues, beneficiaries, emergencyContacts, addedChilds, note } }

        let data = {
          clientsInfo: values,
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id'),
          userEmail: localStorage.getItem('email'),
          isProspect: 0,
          totalClients: 1,
        }

        await axios
            .post('/api/client/createClientList', data)
            .then(async response => {
              if (response.data['ID'] !== null) {
                document.getElementById('closemodal').click();
                document.getElementById("addform").reset();
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Client created successfully!'
                });
              }
            })
            .catch(async error => {
              if (error.response) {
                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },

    async deleteAgent() {
      const data = {
        token: localStorage.getItem('jwt'),
        userID: localStorage.getItem('id'),
        userName: localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastname'),
        userEmail: localStorage.getItem('email'),
        agentID: localStorage.getItem('selectedUser')
      }

      Swal.fire({
        title: 'Do you want to <b>Delete</b> this agent?',
        showDenyButton: true,
        confirmButtonText: 'Yes',
        denyButtonText: `No`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          await axios
              .put('/api/deleteUser', data)
              .then(async response => {
                if (response) {
                  await Swal.fire('Agent update successfully!', '', 'success');
                }
              })
              .catch(async error => {
                if (error.response) {
                  let list = '';
                  for (const property in error.response.data) {
                    this.errors.push(`${property}: ${error.response.data[property]}`)
                    list += '\n' + '<b>' + error.response.data[property] + '</b>';
                  }

                  await Swal.fire({
                    title: "Please check the following: " + list,
                    icon: 'warning',
                    confirmButtonClass: "btn btn-info",
                    buttonsStyling: false,
                    showCloseButton: true,
                  });

                } else if (error.message) {
                  this.errors.push('Something was wrong, please contact your SysAdmin.')
                }
              })
        } else if (result.isDenied) {
          await Swal.fire('Agent wasn\'t updated!', '', 'info');
        }
      })
    },

    async getDepartments() {
      await axios
          .post('/api/getDepartments')
          .then(response => {
            console.log(response);
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Something was wrong, please contact your SysAdmin.", "error")
            }
          })
    },

    async getUserInfo(id) {
      document.getElementById('edit-btn').style.display = 'block';
      document.getElementById('add-btn').style.display = 'none'
      this.modalFormTitle = "Edit Client";

      const data = { token: localStorage.getItem('jwt'), ID: id }
      let agentInfo;

      await axios
          .post('/api/getUser', data)
          .then(response => {
            agentInfo = response.data
            this.setAgentData(agentInfo);
            document.getElementById('id').value = agentInfo.ID
            document.getElementById('editEmail').value = agentInfo.email;
            document.getElementById('editFirstName').value = agentInfo.firstName;
            document.getElementById('editLastName').value = agentInfo.lastName;
            document.getElementById('editLanguage').value = agentInfo.language;
            document.getElementById('editStatus').value = agentInfo.status
            document.getElementById('editPhoneNumber').value = agentInfo.phoneNumber;
            document.getElementById('editDepartment').value = agentInfo.departmentID;
            document.getElementById('editBirthDate').value = agentInfo.dateOfBirth;
            document.getElementById('editAddress').value = agentInfo.address;
            document.getElementById('editState').value = agentInfo.state;
            document.getElementById('editPostalCode').value = agentInfo.postalCode;
            document.getElementById('editAgentNumber').value = agentInfo.agentNumber;
            document.getElementById('editCreatedBy').value = agentInfo.createdBy;
            document.getElementById('editLicensed').value = agentInfo.isLicensed;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Something was wrong, please contact your SysAdmin.", "error")
            }
          })
    },

    async getClientInfo(id) {
      this.openCreate = 0;
      this.modalFormTitle = "Edit Client";

      const data = { token: localStorage.getItem('jwt'), ID: id }

      await this.getNotes(id)
      let clientInfo;

      await axios
          .post('/api/client/getClient', data)
          .then(response => {
            clientInfo = response.data;
            this.setClientData(response.data);
            // Populate traffic light fields
            this.clientData.ID = clientInfo.ID;
            this.clientData.lastVisitDate = clientInfo.lastVisitDate;
            this.clientData.markerColor = clientInfo.markerColor;
            
            document.getElementById('id').value = clientInfo.ID
            document.getElementById('editEmail').value = clientInfo.email;
            localStorage.setItem('selectedUser', clientInfo.ID);
            localStorage.setItem('selectedUserName', clientInfo.firstName + ' ' + clientInfo.lastName);
            this.getMapsLink()
            this.getFiles(id);
            this.crmSelectedUser = clientInfo.ID;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Something was wrong, please contact your SysAdmin.", "error")
            }
          })
    },

    async markVisitPending(id) {
      const result = await Swal.fire({
          title: 'Mark as Visited \u2013 No Response?',
          text: "Are you sure you want to mark this visit as visited \u2013 no response?",
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#fd7e14',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Yes, Mark Visited \u2013 No Response'
      });

      if (result.isConfirmed) {
        const data = {
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id'),
          clientID: id
        };

        const res = await axios.post('/api/client/markVisitPending', data);
        if (res.data.success) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });

          Toast.fire({
            icon: 'success',
            title: 'Client visit marked as Visited \u2013 No Response'
          });

          // Refresh the list and the modal if open
          await this.updateClientList(this.data.searchValues.status, true);
          
          if (this.clientData && this.clientData.ID == id) {
            this.clientData.markerColor = 'orange';
          }

          const listItem = this.list.find(item => item.ID == id);
          if (listItem) {
            listItem.markerColor = 'orange';
          }

          if (this.mapMarkers && this.mapMarkers.length > 0) {
            const markerIndex = this.mapMarkers.findIndex(m => m.ID == id || m.id == id);
            if (markerIndex !== -1) {
              this.mapMarkers[markerIndex].markerColor = 'orange';
            }
          }

          if (this.selectedMapMarker && (this.selectedMapMarker.ID == id || this.selectedMapMarker.id == id)) {
            this.selectedMapMarker.markerColor = 'orange';
          }
        }
      }
    },

    async updateClientList(status = this.data.searchValues.status, keepPage = false) {
      let validate = true;
      let errors = [];
      let filterLanguage = document.getElementById("filterLanguage") ? document.getElementById("filterLanguage").value : '';
      let filterKeyword = document.getElementById("filterKeyword") ? document.getElementById("filterKeyword").value : '';
      let filterNotes = document.getElementById("filterNotes") ? document.getElementById("filterNotes").value : '';
      let filterFromDate = document.getElementById("filterFromDate") ? document.getElementById("filterFromDate").value : '';
      let filterToDate = document.getElementById("filterToDate") ? document.getElementById("filterToDate").value : '';
      let filterDNC = document.getElementById("filterDNC") ? document.getElementById("filterDNC").value : '';

      if (status === 0 || status === '0') {
        this.data.searchValues.status = [];
      } else if (status !== undefined && status !== null) {
        if (Array.isArray(status)) {
          this.data.searchValues.status = status.map(s => String(s));
        } else {
          this.data.searchValues.status = [String(status)];
        }
      }

      if (!Array.isArray(this.data.searchValues.type)) {
        if (this.data.searchValues.type && this.data.searchValues.type !== '0') {
          this.data.searchValues.type = [this.data.searchValues.type];
        } else {
          this.data.searchValues.type = [];
        }
      }

      if (filterDNC === '') {
        filterDNC = 'exclude';
      }
      this.data.searchValues.dncFilter = filterDNC;

      if (!keepPage) {
        this.page = 1;
      }

      if (filterLanguage !== '' && (filterLanguage === '1' || filterLanguage === '2')) {
        this.data.searchValues.language = filterLanguage;
      }

      if (filterKeyword !== '' && filterKeyword.length >= 3) {
        this.data.searchValues.keyword = filterKeyword;
      } else if (filterKeyword !== '' && filterKeyword.length < 3) {
        errors.push('Keyword search should have 3 or more characters!')
        validate = false;
      }

      if (filterNotes !== '' && filterNotes.length >= 3) {
        this.data.searchValues.noteSearch = filterNotes;
      } else if (filterNotes !== '' && filterNotes.length < 3) {
        errors.push('Notes search should have 3 or more characters!')
        validate = false;
      }

      this.data.searchValues.fromDate = filterFromDate;
      this.data.searchValues.toDate = filterToDate;

      let typeAhead = document.getElementById('typeahead_id')

      this.data.searchValues.ageMin = this.data.searchValues.age[0];
      this.data.searchValues.ageMax = this.data.searchValues.age[1];

      const data = {
        token: localStorage.getItem('jwt'),
        isProspect: 0,
        searchValues: this.data.searchValues,
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        deleted: 0,
        agentSearch: (typeAhead != null && typeof (typeAhead) != 'undefined') ? typeAhead.value : [],
        page: this.page,
        perPage: this.perPage,
      };

      if (validate) {
        this.isLoading = true;
        await axios
            .post('/api/client/listClients', data)
            .then(response => {
              this.list = response.data.results;
              this.listQty = response.data.total;
              this.setPages();
            })
            .catch(error => {
              if (error.response) {
                if (error.response.data.detail === 'Your session is expired!') {
                  this.$router.push('logout')
                }
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                }
              }
            })
        this.isLoading = false;
      } else {
        let list = '';
        for (var i = 0; i < errors.length; i += 1) {
          list += errors[i] + ' \n';
        }
        await Swal.fire("" + list, '', 'info');
      }
    },

    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.trim());
    },

    validPhone: function (phone) {
      var isphone = /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm.test(phone);
      return isphone;
    },

    formatDate: function (date, format) {
      date = moment(date).format(format)
      return date;
    },
    formatDateCT: function (date) {
      if (!date) return ' ';
      const d = new Date(date);
      if (isNaN(d.getTime())) return ' ';
      return d.toLocaleString('en-US', {
        timeZone: 'America/Chicago',
        month: 'long',
        day: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    },

    formatPhone: function (phone, flag = 0) {
      phone = phone.replace(/\D/g, '')

      if (phone !== undefined) {
        if (phone.length > 10) {
          phone = phone.substring(1)
        }
        const x = phone.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        phone = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
      } else {
        phone = ''
      }

      if (flag !== 1) {
        return phone;
      } else {
        document.getElementById('editPhoneNumber').value = phone;
      }
    },

    setAgentData: function (data) {
      this.agentData.email = data.email;
      this.agentData.firstName = data.firstName;
      this.agentData.lastName = data.lastName;
      this.agentData.language = data.language;
      this.agentData.status = data.status
      this.agentData.phone = data.phoneNumber;
      this.agentData.department = data.departmentID
      this.agentData.birthDate = this.formatDate(data.dateOfBirth, 'DD MM, YYYY');
      this.agentData.interview = this.formatDate(data.interviewDate, 'm-d-y H:i K');
      this.agentData.address = data.address;
      this.agentData.state = data.state;
      this.agentData.country = data.country;
      this.agentData.zipCode = data.postalCode;
      this.agentData.agentNumber = data.agentNumber;
      this.agentData.createdBy = data.createdBy;
      this.agentData.insuranceLicense = data.isLicensed;
    },

    resetAgentData: function () {
      this.agentData = {
        username: '',
        email: '',
        firstName: '',
        lastName: '',
        language: '',
        status: '',
        phone: '',
        department: '',
        state: '',
        birthDate: '',
        address: '',
        country: 'USA',
        zipCode: '',
        interview: '',
        agentNumber: '',
        createdBy: '',
        insuranceLicense: '',
        licenseNumber: ''
      }
      this.clientData = {
        ID: null,
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        address: '',
        postalCode: '',
        city: '',
        state: '',
        country: 'USA',
        gender: '',
        language: '',
        status: '',
        leadType: '',
        type: '',
        policyNumber: '',
        departmentID: '',
        birthday: '',
        interview: '',
        agentNumber: '',
        createdBy: '',
        markerColor: null,
        lastVisitDate: null,
        donotcall: 0,
        age: '',
        age_source: '',
        note: ''
      };
      this.notesData = [];
      this.messagesData = [];
      this.file = [];
    },

    setPages() {
      const numberOfPages = Math.ceil(this.listQty / this.perPage);
      this.pages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },

    paginate(companies) {
      return companies
    },

    addBeneficiary(benList = []) {
      this.beneficiaryQty = this.beneficiaryQty + 1;
      let i = this.beneficiaryQty;
      let div = document.getElementById('addBeneficiary');
      let separator = '';
      let checkIDExists = document.getElementById("benFirstName-1");
      var element = document.createElement('div');

      if (benList.length <= 0) {
        benList.push(
            benList['firstName'] = '',
            benList['lastName'] = '',
            benList['address'] = '',
            benList['phoneNumber'] = '',
            benList['state'] = '',
            benList['postalCode'] = '',
            benList['relationship'] = '',
            benList['age'] = ''
        );
      }

      if (checkIDExists) {
        separator = '<hr style="border-top: 1px solid #2c9a2a;">';
      }

      element.innerHTML += '<div class="row" id="rowBen' + i + '">\n' + separator +
          '  <div class="col-lg-6">\n' +
          '    <label for="benFirstName-' + i + '" class="form-label">First Name</label>\n' +
          '    <input type="text" id="benFirstName-' + i + '" class="form-control mb-2" placeholder="Enter First Name" name="benFirstName[]" required value="' + benList['firstName'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="benLastName-' + i + '" class="form-label">Last Name</label>\n' +
          '    <input type="text" id="benLastName-' + i + '" class="form-control mb-2" placeholder="Enter Last Name"  name="benLastName[]" required value="' + benList['lastName'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="benAddress-' + i + '" class="form-label">Address</label>\n' +
          '    <input type="text" id="benAddress-' + i + '" class="form-control mb-2" placeholder="Enter Address"  name="benAddress[]" required value="' + benList['address'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="benPhone-' + i + '" class="form-label">Phone</label>\n' +
          '    <input type="text" id="benPhone-' + i + '" class="form-control mb-2" placeholder="Enter Phone"  name="benPhone[]" required value="' + benList['phoneNumber'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="benState-' + i + '" class="form-label">State</label>\n' +
          '    <input type="text" id="benState-' + i + '" class="form-control mb-2" placeholder="Enter State"  name="benState[]"  required value="' + benList['state'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="benPostalCode-' + i + '" class="form-label">Postal Code</label>\n' +
          '    <input type="text" id="benPostalCode-' + i + '" class="form-control mb-2" placeholder="Enter Postal Code"  name="benPostalCode[]" required value="' + benList['postalCode'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="benRelation-' + i + '" class="form-label">Relationship</label>\n' +
          '    <input type="text" id="benRelation-' + i + '" class="form-control mb-2" placeholder="Enter Relationship"  name="benRelation[]"  required value="' + benList['relationship'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="benAge-' + i + '" class="form-label">Age</label>\n' +
          '    <input type="text" id="benAge-' + i + '" class="form-control mb-2" placeholder="Enter Age"  name="benAge[]" required value="' + benList['age'] + '">\n' +
          '  </div>\n' +
          ' <div class="col-md-6" style="display: flex; justify-content: flex-end;">\n' +
          ' </div>\n' +
          ' <div class="col-md-6" style="display: flex; justify-content: flex-end;">\n' +
          '    <button type="button" id="' + i + '" class="btn btn-danger removeItemBen" title="Delete"><i class="ri-close-circle-line"></i></button>\n' +
          ' </div>\n' +
          '</div>';

      div.appendChild(element);
    },

    addEcontact(eContact = []) {
      this.eContactQty = this.eContactQty + 1;
      let i = this.eContactQty;
      let div = document.getElementById('addEcontact');
      let separator = '';
      let checkIDExists = document.getElementById("eConFirstName-1");
      var element = document.createElement('div');

      if (eContact.length <= 0) {
        eContact.push(
            eContact['firstName'] = '',
            eContact['lastName'] = '',
            eContact['address'] = '',
            eContact['phoneNumber'] = '',
            eContact['state'] = '',
            eContact['postalCode'] = '',
            eContact['relationship'] = '',
            eContact['age'] = ''
        );
      }

      if (checkIDExists) {
        separator = '<hr style="border-top: 1px solid #2c9a2a;">';
      }

      element.innerHTML += separator +
          '<div class="row" id="rowEcon' + i + '">\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="eConFirstName-' + i + '" class="form-label">First Name</label>\n' +
          '    <input type="text" id="eConFirstName-' + i + '" class="form-control mb-2" placeholder="Enter First Name" name="eConFirstName[]" required value="' + eContact['firstName'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="eConLastName-' + i + '" class="form-label">Last Name</label>\n' +
          '    <input type="text" id="eConLastName-' + i + '" class="form-control mb-2" placeholder="Enter Last Name"  name="eConLastName[]" required  value="' + eContact['lastName'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="eConAddress-' + i + '" class="form-label">Address</label>\n' +
          '    <input type="text" id="eConAddress-' + i + '" class="form-control mb-2" placeholder="Enter Address"  name="eConAddress[]" required  value="' + eContact['address'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="eConPhone-' + i + '" class="form-label">Phone</label>\n' +
          '    <input type="text" id="eConPhone-' + i + '" class="form-control mb-2" placeholder="Enter Phone"  name="eConPhone[]" required  value="' + eContact['phoneNumber'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="eConState-' + i + '" class="form-label">State</label>\n' +
          '    <input type="text" id="eConState-' + i + '" class="form-control mb-2" placeholder="Enter State"  name="eConState[]"  required  value="' + eContact['state'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="eConPostalCode-' + i + '" class="form-label">Postal Code</label>\n' +
          '    <input type="text" id="eConPostalCode-' + i + '" class="form-control mb-2" placeholder="Enter Postal Code"  name="eConPostalCode[]" required  value="' + eContact['postalCode'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="eConRelation-' + i + '" class="form-label">Relationship</label>\n' +
          '    <input type="text" id="eConRelation-' + i + '" class="form-control mb-2" placeholder="Enter Relationship"  name="eConRelation[]"  required  value="' + eContact['relationship'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="eConAge-' + i + '" class="form-label">Age</label>\n' +
          '    <input type="text" id="eConAge-' + i + '" class="form-control mb-2" placeholder="Enter Age"  name="eConAge[]" required  value="' + eContact['age'] + '">\n' +
          '  </div>\n' +
          ' <div class="col-md-6" style="display: flex; justify-content: flex-end;">\n' +
          ' </div>\n' +
          ' <div class="col-md-6" style="display: flex; justify-content: flex-end;">\n' +
          '    <button type="button" id="' + i + '" class="btn btn-danger removeItemEcon" title="Delete"><i class="ri-close-circle-line"></i></button>\n' +
          ' </div>\n' +
          '</div>';

      div.append(element);
    },

    addAdditaments(additaments = []) {
      this.additamentsQty = this.additamentsQty + 1;
      let i = this.additamentsQty;
      let div = document.getElementById('addAdditaments');
      let separator = '';
      let checkIDExists = document.getElementById("eConFirstName-1");
      var element = document.createElement('div');

      if (additaments.length <= 0) {
        additaments.push(
            additaments['firstName'] = '',
            additaments['lastName'] = '',
            additaments['gender'] = 0,
            additaments['retalionship'] = 0,
            additaments['age'] = ''
        );
      }

      if (checkIDExists) {
        separator = '<hr style="border-top: 1px solid #2c9a2a;">';
      }

      element.innerHTML += separator +
          '<div class="row" id="rowAdditaments' + i + '">\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="AddiFirstName-' + i + '" class="form-label">First Name</label>\n' +
          '    <input type="text" id="AddiFirstName-' + i + '" class="form-control mb-2" placeholder="Enter First Name" name="AddiFirstName[]" required value="' + additaments['firstName'] + '">\n' +
          '  </div>\n' +
          '  <div class="col-lg-6">\n' +
          '    <label for="AddiLastName-' + i + '" class="form-label">Last Name</label>\n' +
          '    <input type="text" id="AddiLastName-' + i + '" class="form-control mb-2" placeholder="Enter Last Name"  name="AddiLastName[]" required value="' + additaments['lastName'] + '">\n' +
          '  </div>\n' +
          '<div class="col-lg-6">' +
          '  <label for="AddiGender" class="form-label">Gender</label>' +
          '  <select class="form-select mb-2" aria-label="Gender" id="AddiGender-' + i + '" name="AddiGender[]">' +
          '    <option value="0" >Select...</option>' +
          '    <option value="F">Female</option>' +
          '    <option value="M">Male</option>' +
          '</select>' +
          '</div>\n' +
          '<div class="col-lg-6">\n' +
          '  <label for="AddiAge-' + i + '" class="form-label">Age</label>\n' +
          '  <input type="text" id="AddiAge-' + i + '" class="form-control mb-2" placeholder="Enter Age"  name="AddiAge[]" required  value="' + additaments['age'] + '">\n' +
          '</div>\n' +
          ' <div class="col-md-6">\n' +
          '  <label for="AddiRelation-' + i + '" class="form-label">Relationship</label>' +
          '  <select class="form-select mb-2" aria-label="AddiRelation" id="AddiRelation-' + i + '" name="AddiRelation[]"  value="' + additaments['retalionship'] + '">' +
          '    <option value="0">Relation</option>' +
          '    <option value="C">Children</option>' +
          '    <option value="S">Stepson</option>' +
          '    <option value="G">Grandson</option>' +
          '</select>' +
          ' </div>\n' +
          ' <div class="col-md-6" style="display: flex; justify-content: flex-end;">\n' +
          '    <button type="button" id="' + i + '" class="btn btn-danger removeItemAdditaments" title="Delete"><i class="ri-close-circle-line"></i></button>\n' +
          ' </div>\n' +
          '</div>';

      div.append(element);
      document.getElementById("AddiGender-" + i + "").value = additaments['gender'];
      document.getElementById("AddiRelation-" + i + "").value = additaments['retalionship'];
    },

    getBenficiaries() {
      let nameValues = [];
      let lastValues = [];
      let phoneValues = [];
      let addressValues = [];
      let stateValues = [];
      let postalValues = [];
      let relationValues = [];
      let ageValues = [];
      let values = [];

      let benFirstName = document.querySelectorAll("input[name='benFirstName[]']");
      for (let i = 0; i < benFirstName.length; i++) nameValues.push(benFirstName[i].value);

      let benLastName = document.querySelectorAll("input[name='benLastName[]']");
      for (let i = 0; i < benLastName.length; i++) lastValues.push(benLastName[i].value);

      let benPhone = document.querySelectorAll("input[name='benPhone[]']");
      for (let i = 0; i < benPhone.length; i++) phoneValues.push(benPhone[i].value);

      let benAddress = document.querySelectorAll("input[name='benAddress[]']");
      for (let i = 0; i < benAddress.length; i++) addressValues.push(benAddress[i].value);

      let benState = document.querySelectorAll("input[name='benState[]']");
      for (let i = 0; i < benState.length; i++) stateValues.push(benState[i].value);

      let benPostalCode = document.querySelectorAll("input[name='benPostalCode[]']");
      for (let i = 0; i < benPostalCode.length; i++) postalValues.push(benPostalCode[i].value);

      let benRelation = document.querySelectorAll("input[name='benRelation[]']");
      for (let i = 0; i < benRelation.length; i++) relationValues.push(benRelation[i].value);

      let benAge = document.querySelectorAll("input[name='benAge[]']");
      for (let i = 0; i < benAge.length; i++) ageValues.push(benAge[i].value);

      for (let i = 0; i < nameValues.length; i++) {
        values.push({
          'firstName': nameValues[i],
          'lastName': lastValues[i],
          'phoneNumber': phoneValues[i],
          'address': addressValues[i],
          'state': stateValues[i],
          'postalCode': postalValues[i],
          'relationship': relationValues[i],
          'age': ageValues[i]
        });
      }
      return values;
    },

    getEmergency() {
      let nameValues = [];
      let lastValues = [];
      let phoneValues = [];
      let addressValues = [];
      let stateValues = [];
      let postalValues = [];
      let relationValues = [];
      let ageValues = [];
      let values = [];

      let eConFirstName = document.querySelectorAll("input[name='eConFirstName[]']");
      for (let i = 0; i < eConFirstName.length; i++) nameValues.push(eConFirstName[i].value);

      let eConLastName = document.querySelectorAll("input[name='eConLastName[]']");
      for (let i = 0; i < eConLastName.length; i++) lastValues.push(eConLastName[i].value);

      let eConPhone = document.querySelectorAll("input[name='eConPhone[]']");
      for (let i = 0; i < eConPhone.length; i++) phoneValues.push(eConPhone[i].value);

      let eConAddress = document.querySelectorAll("input[name='eConAddress[]']");
      for (let i = 0; i < eConAddress.length; i++) addressValues.push(eConAddress[i].value);

      let eConState = document.querySelectorAll("input[name='eConState[]']");
      for (let i = 0; i < eConState.length; i++) stateValues.push(eConState[i].value);

      let eConPostalCode = document.querySelectorAll("input[name='eConPostalCode[]']");
      for (let i = 0; i < eConPostalCode.length; i++) postalValues.push(eConPostalCode[i].value);

      let eConRelation = document.querySelectorAll("input[name='eConRelation[]']");
      for (let i = 0; i < eConRelation.length; i++) relationValues.push(eConRelation[i].value);

      let eConAge = document.querySelectorAll("input[name='eConAge[]']");
      for (let i = 0; i < eConAge.length; i++) ageValues.push(eConAge[i].value);

      for (let i = 0; i < nameValues.length; i++) {
        values.push({
          'firstName': nameValues[i],
          'lastName': lastValues[i],
          'phoneNumber': phoneValues[i],
          'address': addressValues[i],
          'state': stateValues[i],
          'postalCode': postalValues[i],
          'relationship': relationValues[i],
          'age': ageValues[i]
        });
      }
      return values;
    },

    getAddedChilds() {
      let nameValues = [];
      let lastValues = [];
      let genderValues = [];
      let ageValues = [];
      let relationValues = [];
      let values = [];

      let eConFirstName = document.querySelectorAll("input[name='AddiFirstName[]']");
      for (let i = 0; i < eConFirstName.length; i++) nameValues.push(eConFirstName[i].value);

      let eConLastName = document.querySelectorAll("input[name='AddiLastName[]']");
      for (let i = 0; i < eConLastName.length; i++) lastValues.push(eConLastName[i].value);

      let AddiGender = document.querySelectorAll("select[name='AddiGender[]']");
      for (let i = 0; i < AddiGender.length; i++) genderValues.push(AddiGender[i].value);

      let AddiAge = document.querySelectorAll("input[name='AddiAge[]']");
      for (let i = 0; i < AddiAge.length; i++) ageValues.push(AddiAge[i].value);

      let AddiRelation = document.querySelectorAll("select[name='AddiRelation[]']");
      for (let i = 0; i < AddiRelation.length; i++) relationValues.push(AddiRelation[i].value);

      for (let i = 0; i < nameValues.length; i++) {
        values.push({
          'firstName': nameValues[i],
          'lastName': lastValues[i],
          'gender': genderValues[i],
          'age': ageValues[i],
          'retalionship': relationValues[i]
        });
      }
      return values;
    },

    setClientData(clientInfo) {
      this.clientData.email = clientInfo.email;
      this.clientData.firstName = clientInfo.firstName;
      this.clientData.lastName = clientInfo.lastName;
      this.clientData.language = clientInfo.language;
      this.clientData.status = clientInfo.status;
      this.clientData.phoneNumber = clientInfo.phoneNumber;
      this.clientData.gender = clientInfo.gender;
      this.clientData.age = clientInfo.age;
      this.clientData.type = (clientInfo.type !== '') ? clientInfo.type : clientInfo.leadType;
      this.clientData.city = clientInfo.city;
      this.clientData.departmentID = clientInfo.departmentID;
      this.clientData.donotcall = Number(clientInfo.donotcall);
      this.clientData.leadType = clientInfo.leadType;
      this.clientData.birthday = this.formatDate(clientInfo.dateOfBirth, 'DD MMM, YYYY');
      this.clientData.interview = this.formatDate(clientInfo.interviewDate, 'MMMM D, YYYY H:mm A');
      this.clientData.address = clientInfo.address;
      this.clientData.state = clientInfo.state;
      this.clientData.country = clientInfo.country;
      this.clientData.postalCode = clientInfo.postalCode;
      this.clientData.agentNumber = clientInfo.agentNumber;
      this.clientData.createdBy = clientInfo.createdBy;
      this.clientData.insuranceLicense = clientInfo.isLicensed;
      this.clientData.markerColor = clientInfo.markerColor || 'red';
      this.clientData.lastVisitDate = clientInfo.lastVisitDate;
      this.clientData.policyNumber = clientInfo.policyNumber;
    },

    async markVisited(id) {
      const result = await Swal.fire({
        title: 'Mark as Visited?',
        text: "Are you sure you want to mark this client as visited today?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#198754',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Yes, Mark Visited'
      });

      if (result.isConfirmed) {
        const data = {
          token: localStorage.getItem('jwt'),
          userID: localStorage.getItem('id'),
          clientID: id
        };

        const res = await axios.post('/api/client/markVisited', data);
        if (res.data.success) {
          const Toast = Swal.mixin({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });

          Toast.fire({
            icon: 'success',
            title: 'Client marked as visited'
          });

          // Refresh the list and the modal if open
          await this.updateClientList(this.data.searchValues.status, true);
          
          // Update modal state instantly
          if (this.clientData && this.clientData.ID == id) {
            this.clientData.markerColor = 'green';
            this.clientData.lastVisitDate = new Date().toISOString();
          }

          // Update marker in the local list for immediate visual feedback in the table
          const listItem = this.list.find(item => item.ID == id);
          if (listItem) {
            listItem.markerColor = 'green';
            listItem.lastVisitDate = new Date().toISOString();
          }

          // Update mapMarkers if they exist
          if (this.mapMarkers && this.mapMarkers.length > 0) {
            const markerIndex = this.mapMarkers.findIndex(m => m.ID == id || m.id == id);
            if (markerIndex !== -1) {
              this.mapMarkers[markerIndex].markerColor = 'green';
              this.mapMarkers[markerIndex].lastVisitDate = new Date().toISOString();
            }
          }

          // Update selectedMapMarker if it's the one that was visited
          if (this.selectedMapMarker && (this.selectedMapMarker.ID == id || this.selectedMapMarker.id == id)) {
            this.selectedMapMarker.markerColor = 'green';
            this.selectedMapMarker.lastVisitDate = new Date().toISOString();
          }
        }
      }
    },

    async getNotes(id = localStorage.getItem('selectedUser'), name) {
      const data = {
        token: localStorage.getItem('jwt'),
        userID: localStorage.getItem('id'),
        agentID: id,
        clientID: id,
      }
      localStorage.setItem('selectedUserName', name)
      localStorage.setItem('selectedUser', id)

      let url = '/api/client/getClientNotes';

      await axios
          .post(url, data)
          .then(response => {
            this.notesData = response.data;
          })
          .catch(error => {
            if (error.response) {
              Swal.fire("Oops!", "Notes could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },

    async getProspectStatus(id) {
      localStorage.setItem('selectedUser', id)
      const data = {
        token: localStorage.getItem('jwt'),
        searchValues: this.data.searchValues,
        userEmail: localStorage.getItem('email'),
        userID: localStorage.getItem('id'),
        isProspect: 1,
      }

      await axios
          .post('/api/client/clientStatus', data)
          .then(response => {
            this.prospectStatusList = response.data
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },

    async moveClient() {
      let client = localStorage.getItem('selectedUser');

      const data = {
        token: localStorage.getItem('jwt'),
        searchValues: this.data.searchValues,
        userEmail: localStorage.getItem('email'),
        client: client,
        status: document.getElementById('moveStatus').value,
        isProspect: 1,
      }

      await axios
          .put('/api/client/moveClient', data)
          .then(async response => {
            document.getElementById('closeMove').click();
            if (response.status === 200) {
              await this.updateClientList();

              await Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Your Client was moved to Prospect List",
                showConfirmButton: false,
                timer: 5000,
              });
            }
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },

    filterStatus(status) {
      var statusButton = document.getElementById(status);
      statusButton.click();
    },

    deleteClient(ID) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-danger ml-2",
          cancelButton: "btn btn-success",
        },
        buttonsStyling: false,
      });

      localStorage.setItem('selectedUser', ID)

      swalWithBootstrapButtons
          .fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
            showCancelButton: true,
          })
          .then((result) => {
            if (result.value) {
              const data = {
                token: localStorage.getItem('jwt'),
                userID: localStorage.getItem('id'),
                userName: localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastname'),
                userEmail: localStorage.getItem('email'),
                agentID: localStorage.getItem('selectedUser')
              }

              axios
                  .put('/api/client/delete', data)
                  .then(async response => {
                    if (response) {
                      await this.updateClientList()
                      await swalWithBootstrapButtons.fire(
                          "Deleted!",
                          "Client has been deleted.",
                          "success"
                      );
                    }
                  })
                  .catch(async error => {
                    if (error.response) {
                      let list = '';
                      for (const property in error.response.data) {
                        this.errors.push(`${property}: ${error.response.data[property]}`)
                        list += '\n' + '<b>' + error.response.data[property] + '</b>';
                      }

                      await Swal.fire({
                        title: "Please check the following: " + list,
                        icon: 'warning',
                        confirmButtonClass: "btn btn-info",
                        buttonsStyling: false,
                        showCloseButton: true,
                      });

                    } else if (error.message) {
                      this.errors.push('Something was wrong, please contact your SysAdmin.')
                    }
                  })
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              swalWithBootstrapButtons.fire(
                  "Cancelled",
                  "Client is in a safe place :)",
                  "error"
              );
            }
          });
    },

    handleFocus(e) {
      e.target.setAttribute("autocomplete", "nope");
    },

    getMapsLink() {
      let link = 'https://maps.google.com/?q='
      let clientData = this.clientData;
      if (clientData.address.length > 0) link += '+' + this.clientData.address
      if (clientData.postalCode.length > 0) link += '+' + clientData.postalCode
      if (clientData.city.length > 0) link += '+' + clientData.city
      if (clientData.state.length > 0) link += '+' + clientData.state

      if (link !== 'https://maps.google.com/?q=') {
        document.getElementById("gMapsLink").href = link;
      } else {
        document.getElementById("gMapsLink").href = '#';
      }
    },

    // ========== ENHANCED UPLOAD WIZARD METHODS ==========
    selectedFile(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      this.uploadedFile = file;
      this.parseUploadedFile(file);
    },
    async parseUploadedFile(file) {
      const fileName = file.name.toLowerCase();
      const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
      
      try {
        if (fileExtension === '.csv') {
          await this.parseCSVFile(file);
        } else if (fileExtension === '.xlsx' || fileExtension === '.xls') {
          await this.parseExcelFile(file);
        } else {
          await Swal.fire({
            title: "Unsupported File Type",
            text: "Please upload a CSV or Excel file (.csv, .xlsx, .xls)",
            icon: 'warning',
            confirmButtonClass: "btn btn-info",
            buttonsStyling: false,
          });
        }
      } catch (error) {
        console.error('Error parsing file:', error);
        await Swal.fire({
          title: "Error Parsing File",
          text: "There was an error reading your file. Please try again.",
          icon: 'error',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
        });
      }
    },
    parseCSVFile(file) {
      return new Promise((resolve, reject) => {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            this.parsedHeaders = results.meta.fields || [];
            this.parsedData = results.data || [];
            this.autoDetectColumns();
            resolve();
          },
          error: (error) => {
            reject(error);
          }
        });
      });
    },
    parseExcelFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        
        reader.onload = (e) => {
          try {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            
            // Get first sheet
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            
            // Convert to JSON
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
            
            if (jsonData.length > 0) {
              // First row is headers - ensure all are strings and filter empty
              this.parsedHeaders = jsonData[0].map(h => String(h || '').trim()).filter(h => h);
              
              // Rest is data
              this.parsedData = jsonData.slice(1).map(row => {
                const obj = {};
                this.parsedHeaders.forEach((header, index) => {
                  obj[header] = row[index] !== undefined ? String(row[index]) : '';
                });
                return obj;
              });
              
              this.autoDetectColumns();
              resolve();
            } else {
              reject(new Error('Empty file'));
            }
          } catch (error) {
            reject(error);
          }
        };
        
        reader.onerror = (error) => {
          reject(error);
        };
        
        reader.readAsArrayBuffer(file);
      });
    },
    autoDetectColumns() {
      // Auto-detect column mapping based on header names
      const mapping = {};
      
      this.parsedHeaders.forEach(header => {
        // Ensure header is a string before calling toLowerCase()
        if (!header || typeof header !== 'string') return;
        const lowerHeader = header.toLowerCase().trim();
        
        // Full Name detection (check this first before firstName/lastName)
        if (lowerHeader.includes('full') && lowerHeader.includes('name') || 
            lowerHeader === 'fullname' || 
            lowerHeader === 'nombre completo' ||
            lowerHeader === 'name') {
          mapping[header] = 'fullName';
        }
        // First Name detection
        else if (lowerHeader.includes('first') || lowerHeader.includes('nombre') || lowerHeader === 'firstname') {
          mapping[header] = 'First Name';
        }
        // Last Name detection
        else if (lowerHeader.includes('last') || lowerHeader.includes('apellido') || lowerHeader === 'lastname') {
          mapping[header] = 'Last Name';
        }
        // Address detection
        else if (lowerHeader.includes('address') || lowerHeader.includes('direc') || lowerHeader.includes('ubic')) {
          mapping[header] = 'Address';
        }
        // City detection
        else if (lowerHeader.includes('city') || lowerHeader.includes('ciudad')) {
          mapping[header] = 'City';
        }
        // State detection
        else if (lowerHeader.includes('state') || lowerHeader === 'estado') {
          mapping[header] = 'State';
        }
        // ZIP Code detection
        else if (lowerHeader.includes('zip') || lowerHeader.includes('postal') || lowerHeader.includes('código')) {
          mapping[header] = 'Zip';
        }
        // Age detection
        else if (lowerHeader.includes('age') || lowerHeader.includes('edad')) {
          mapping[header] = 'Age';
        }
        // Daytime Phone detection
        else if (lowerHeader.includes('day') || lowerHeader.includes('día') || lowerHeader.includes('dia')) {
          mapping[header] = 'Daytime Phone';
        }
        // Phone detection (default to Evening Phone as it's required)
        else if (lowerHeader.includes('phone') || lowerHeader.includes('tel') || lowerHeader.includes('móvil') || lowerHeader.includes('celular') || lowerHeader.includes('evening')) {
          mapping[header] = 'Evening Phone';
        }
      });
      
      this.columnMapping = mapping;
    },
    updateColumnMapping(sourceColumn, targetField) {
      if (targetField === '') {
        // Remove mapping
        delete this.columnMapping[sourceColumn];
      } else {
        this.columnMapping[sourceColumn] = targetField;
      }
    },
    getMappedFieldForColumn(column) {
      return this.columnMapping[column] || '';
    },
    nextStep() {
      if (this.uploadStep === 1) {
        // Validate file is uploaded and parsed
        if (!this.uploadedFile || this.parsedHeaders.length === 0) {
          Swal.fire({
            title: "No File Uploaded",
            text: "Please upload a file first",
            icon: 'warning',
            confirmButtonClass: "btn btn-info",
            buttonsStyling: false,
          });
          return;
        }
        this.uploadStep = 2;
      } else if (this.uploadStep === 2) {
        // Validate required fields are mapped
        const requiredFields = this.systemFields.filter(f => f.required).map(f => f.key);
        const mappedFields = Object.values(this.columnMapping);
        
        // Check if fullName is mapped (it satisfies both firstName and lastName)
        const hasFullName = mappedFields.includes('fullName');
        
        const missingFields = requiredFields.filter(field => {
          // If fullName is mapped, firstName and lastName are satisfied
          if (hasFullName && (field === 'First Name' || field === 'Last Name')) {
            return false;
          }
          return !mappedFields.includes(field);
        });
        
        if (missingFields.length > 0) {
          const fieldLabels = missingFields.map(key => {
            const field = this.systemFields.find(f => f.key === key);
            return field ? field.label : key;
          }).join(', ');
          
          Swal.fire({
            title: "Missing Required Fields",
            text: `Please map the following required fields: ${fieldLabels}`,
            icon: 'warning',
            confirmButtonClass: "btn btn-info",
            buttonsStyling: false,
          });
          return;
        }
        
        this.uploadStep = 3;
      }
    },
    previousStep() {
      if (this.uploadStep > 1) {
        this.uploadStep--;
      }
    },
    resetUploadWizard() {
      this.uploadStep = 1;
      this.uploadedFile = null;
      this.parsedHeaders = [];
      this.parsedData = [];
      this.columnMapping = {};
      this.validationErrors = [];
      this.parsed = false;
      this.content = [];
      
      // Reset file input
      const fileInput = document.getElementById('listFile');
      if (fileInput) {
        fileInput.value = '';
      }
    },
    transformDataForUpload() {
      // Transform parsed data according to column mapping
      const transformedData = this.parsedData.map(row => {
        const newRow = {};
        
        // Map columns according to columnMapping
        Object.keys(this.columnMapping).forEach(sourceColumn => {
          const targetField = this.columnMapping[sourceColumn];
          const value = row[sourceColumn] || '';
          
          // Special handling for fullName - split into firstName and lastName
          if (targetField === 'fullName' && value) {
            const nameParts = value.trim().split(/\s+/);
            if (nameParts.length >= 2) {
              // First part is firstName, rest is lastName
              newRow['First Name'] = nameParts[0];
              newRow['Last Name'] = nameParts.slice(1).join(' ');
            } else if (nameParts.length === 1) {
              // Only one name provided, use it as firstName
              newRow['First Name'] = nameParts[0];
              newRow['Last Name'] = '';
            }
          }
          // Special handling for notes
          else if (targetField === 'note' && value) {
            if (!newRow['notes_data']) newRow['notes_data'] = {};
            newRow['notes_data'][sourceColumn] = value;
          }
          // Regular field mapping
          else {
            // For regular fields, use the value (last one wins if multiple columns map to same field)
            newRow[targetField] = value;
          }
        });
        
        return newRow;
      });
      
      // Build fields list, replacing fullName with firstName and lastName
      const fields = Object.values(this.columnMapping).map(field => {
        if (field === 'fullName') {
          return ['First Name', 'Last Name'];
        }
        return field;
      }).flat();
      
      return {
        data: transformedData,
        meta: {
          fields: [...new Set(fields)] // Remove duplicates
        }
      };
    },
    async processAndUpload() {
      // Call the adapted uploadFile method
      await this.uploadFile();
    },
    getMappedPreviewData() {
      // Get the transformed data
      const transformed = this.transformDataForUpload();
      const preview = transformed.data.slice(0, 5);
      
      // Return the preview data with only the mapped fields
      return preview.map(row => {
        const mappedRow = {};
        // Get unique fields from the transformation
        transformed.meta.fields.forEach(field => {
          const fieldDef = this.systemFields.find(f => f.key === field);
          const fieldLabel = fieldDef?.label || field;
          mappedRow[fieldLabel] = row[field] || '';
        });
        return mappedRow;
      });
    },
    getTransformedFieldKeys() {
      // Get the field keys after transformation (fullName becomes First Name + Last Name)
      const transformed = this.transformDataForUpload();
      return transformed.meta.fields;
    },
    getFieldLabel(fieldKey) {
      // Get the label for a field key
      const fieldDef = this.systemFields.find(f => f.key === fieldKey);
      return fieldDef?.label || fieldKey;
    },
    
    async uploadFile() {
      this.errors = []

      if (document.getElementById('uploadLanguage').value === '') this.errors.push('Language is required.');
      if (document.getElementById('uploadStatus').value === '') this.errors.push('Status is required.');
      if (document.getElementById('uploadType').value === '') this.errors.push('Source is required.');

      // Transform data before uploading
      this.content = this.transformDataForUpload();
      this.parsed = true;

      if (this.content.data.length === 0) this.errors.push('Please ensure you have mapped required columns.');

      if (this.errors.length === 0) {
        const data = {
          token: localStorage.getItem('jwt'),
          userEmail: localStorage.getItem('email'),
          userID: localStorage.getItem('id'),
          listOfData: this.content,
          uploadTo: localStorage.getItem('firstName') + ' ' + localStorage.getItem('lastname')
              + ' | ' + localStorage.getItem('email'),
          isProspect: 0,
          language: document.getElementById('uploadLanguage').value,
          status: document.getElementById('uploadStatus').value,
          source: document.getElementById('uploadType').value,
          listType: 1, // Lincoln format
        }

        this.isLoading = true;

        await axios
            .post('/api/client/uploadList', data)
            .then(async response => {
              if (response.status === 200) {
                await Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: 'Uploaded successfully!'
                });
              }
              setTimeout(function () {
                location.reload()
              }, 2000);
            })
            .catch(async error => {
              if (error.response) {
                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })

        this.isLoading = false;
      } else {
        let list = '';
        for (let i = 0; i < this.errors.length; i++)
          list += '\n' + '<b>' + this.errors[i] + '</b>';

        await Swal.fire({
          title: "Please complete the form! " + list,
          icon: 'warning',
          confirmButtonClass: "btn btn-info",
          buttonsStyling: false,
          showCloseButton: true,
        });
      }
    },

    viewUserGroup(request) {
      const currentRole = jwt_decode(localStorage.getItem('jwt'))
      return currentRole.userGroup.includes(request)
    },

    async getSMS(id = localStorage.getItem('selectedUser'), name) {
      const data = {
        token: localStorage.getItem('jwt'),
        userID: localStorage.getItem('id'),
        agentID: id,
        clientID: id,
      }

      localStorage.setItem('selectedUserName', name)
      localStorage.setItem('selectedUser', id)

      let url = '/api/client/getSMSConversation';

      await axios
          .post(url, data)
          .then(response => {
            this.messagesData = response.data;
          })
          .catch(error => {
            if (error.response) {
              Swal.fire("Oops!", "Notes could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },

    async searchAgents(event) {
      let val = [];
      if (event && event.input) {
        val = event.input;
      } else {
        let typeAhead = document.getElementById('typeahead_id');
        val = (typeAhead != null && typeof (typeAhead) != 'undefined') ? typeAhead.value : [];
      }

      const data = {
        token: localStorage.getItem('jwt'),
        searchValue: val,
        condition: 9
      }

      if (data['searchValue'].length > 3) {
        await axios
            .post('/api/userFinder', data)
            .then(async response => {
              this.itemsSearch = response.data;
            })
            .catch(async error => {
              if (error.response) {
                let list = '';
                for (const property in error.response.data) {
                  this.errors.push(`${property}: ${error.response.data[property]}`)
                  list += '\n' + '<b>' + error.response.data[property] + '</b>';
                }

                await Swal.fire({
                  title: "Please check the following: " + list,
                  icon: 'warning',
                  confirmButtonClass: "btn btn-info",
                  buttonsStyling: false,
                  showCloseButton: true,
                });

              } else if (error.message) {
                this.errors.push('Something was wrong, please contact your SysAdmin.')
              }
            })
      }
    },

    viewPermission(request) {
      const currentRole = jwt_decode(localStorage.getItem('jwt'))
      return currentRole.vueViews.includes(request)
    },

    async getFiles(id) {
      const data = {
        token: localStorage.getItem('jwt'),
        ID: id,
        isClient: 1
      }

      if (data.ID === null) data.ID = this.crmSelectedUser;

      await axios
          .post('/api/comm/getFiles', data)
          .then(response => {
            this.fileList = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
              Swal.fire("Oops!", "Something was wrong, please contact your SysAdmin.", "error")
            }
          })
    },

    async getEcontacts() {
      const data = {
        token: localStorage.getItem('jwt'),
        isProspect: 0,
        userEmail: localStorage.getItem('email'),
        clientID: localStorage.getItem('selectedUser'),
        userID: localStorage.getItem('id'),
      }

      await axios
          .post('/api/client/getecontacts', data)
          .then(response => {
            this.eContactlist = []
            this.eContactlist = response.data;
          })
          .catch(error => {
            if (error.response) {
              Swal.fire("Oops!", "Departments could not be loaded, please contact your SysAdmin.", "error")
            }
          })
    },

    async downloadFile(url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      a.click()
    },

    reset: function () {
      this.image = null;
      this.preview = null;
      this.image_list = [];
      this.preview_list = [];
    },

    onAddFile(event) {
      this.uploadFiles = event.newState;
    },

    onRemoveFile(event) {
      this.uploadFiles = event.newState;
    },

    refreshContacts() {
      this.getEcontacts();
    },

    async handleFileUpload() {
      this.file = document.getElementById('listFile').files[0];
      this.parseFile();
    },

    deleteFile(ID) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#348cc3",
        confirmButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          let data = {
            token: localStorage.getItem('jwt'),
            userID: localStorage.getItem('id'),
            userEmail: localStorage.getItem('email'),
            taskID: ID,
            woID: localStorage.getItem('selectedUser')
          }

          await axios
              .put('/api/comm/deleteFile', data)
              .then(async response => {
                if (response.status === 200) {
                  await Swal.fire("Deleted!", "Your file has been deleted.", "success");
                  await this.getFiles(this.crmSelectedUser)
                }
              })
              .catch(async error => {
                if (error.response) {
                  let list = '';
                  for (const property in error.response.data) {
                    this.errors.push(`${property}: ${error.response.data[property]}`)
                    list += '\n' + '<b>' + error.response.data[property] + '</b>';
                  }

                  await Swal.fire({
                    title: "Please check the following: " + list,
                    icon: 'warning',
                    confirmButtonClass: "btn btn-info",
                    buttonsStyling: false,
                    showCloseButton: true,
                  });

                } else if (error.message) {
                  this.errors.push('Something was wrong, please contact your SysAdmin.')
                }
              })
        }
      });
    },
    async verifyPhone() {
      if (!this.phoneVerification) {
        Swal.fire("Please enter a phone number", "", "warning");
        return;
      }
      try {
        const response = await axios.get(`/api/client/verifyPhone?phone=${this.phoneVerification}`);

        if (response.data.status === 'success') {
           const data = response.data.data;
           // Adjust based on actual BLA response structure we saw in functions.py
           // In functions.py:
           // if 'scrubs' or 'dnc' is true -> DNC
           // But the previous frontend code said:
           // if (response.data.message === 'Good') -> Not DNC
           
           // Let's look at what functions.py returns.
           // functions.py returns {status: success, data: ...}
           // The BLA API response is inside `data`.
           
           // If I look at the old code:
           // if (response.data.message === 'Good') { Swal.fire("The number is not DNC", ... "success"); }
           
           // I should probably pass this logic to the backend or replicate it.
           // BLA API usually returns 'message': 'Good' if it's clean, or 'message': 'DNC ...'
           
           if (data.message === 'Good') {
             Swal.fire("The number is not DNC", data.message, "success");
           } else {
             Swal.fire("DNC Alert", data.message || "Number is DNC", "error");
           }
        } else {
             Swal.fire("Error", response.data.message || "Verification failed", "error");
        }
      } catch (error) {
         console.error(error);
         Swal.fire("Error", "Could not verify phone number", "error");
      }
    },

    openModal(imageURl) {
      this.previewImageURL = imageURl;
      const image = document.getElementById("myImage");
      const modal = document.getElementById("myModal");
      const modalImg = document.querySelector(".modal-content-preview");
      modal.style.display = "block";
      modalImg.src = image.src.replace("thumbnail", "full");
    },

    async closeModal() {
      const modal = document.getElementById("myModal");
      modal.style.display = "none";
    },

    // Multi-select methods
    toggleClient(clientId) {
      const index = this.selectedClients.indexOf(clientId);
      if (index > -1) {
        this.selectedClients.splice(index, 1);
        this.selectedClientObjects.splice(index, 1);
      } else {
        const clientObj = this.list.find(c => c.ID === clientId);
        if (clientObj) {
          this.selectedClients.push(clientId);
          this.selectedClientObjects.push(clientObj);
        }
      }
    },

    isClientSelected(clientId) {
      return this.selectedClients.includes(clientId);
    },

    toggleSelectAll(event) {
      if (event.target.checked) {
        this.list.forEach(client => {
          if (!this.selectedClients.includes(client.ID)) {
            this.selectedClients.push(client.ID);
            this.selectedClientObjects.push(client);
          }
        });
      } else {
        // Only deselect the clients on the current page
        this.list.forEach(client => {
          const idx = this.selectedClients.indexOf(client.ID);
          if (idx > -1) {
            this.selectedClients.splice(idx, 1);
            this.selectedClientObjects.splice(idx, 1);
          }
        });
      }
    },

    clearSelection() {
      this.selectedClients = [];
      this.selectedClientObjects = [];
    },

    selectAllCurrentPage() {
      this.list.forEach(client => {
        if (!this.selectedClients.includes(client.ID)) {
          this.selectedClients.push(client.ID);
          this.selectedClientObjects.push(client);
        }
      });
    },

    async bulkDelete() {
      if (this.selectedClients.length === 0) return;

      const result = await Swal.fire({
        title: `Delete ${this.selectedClients.length} client(s)?`,
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete them!'
      });

      if (result.isConfirmed) {
        try {
          // Use the existing BulkDelete endpoint for consistency with prospects if desired, 
          // or use the new bulkDeleteClients I created. I'll use /api/client/bulkDeleteClients.
          await axios.post('/api/client/bulkDeleteClients', {
             token: localStorage.getItem('jwt'),
             ids: this.selectedClients
          });
          await Swal.fire('Deleted!', 'Clients have been deleted.', 'success');
          this.clearSelection();
          this.updateClientList();
        } catch (error) {
          if (error.response && error.response.data.detail === 'Your session is expired!') {
            this.$router.push('logout');
          }
          Swal.fire('Error!', 'Could not delete clients.', 'error');
        }
      }
    },

    openTransferModal() {
      this.selectedTransferAgentId = null;
      let el = document.getElementById('transfer_typeahead_id');
      if (el) el.value = ''; // clear previous search
    },

    selectTransferAgentEventHandler(item) {
      this.selectedTransferAgentId = item;
    },

    async executeBulkTransfer(agentId, isProspect) {
       // agentId argument is ignored as we use selectedTransferAgentId
       if (!this.selectedTransferAgentId) {
         Swal.fire('Error', 'Please select an agent', 'error');
         return;
       }
       
       this.isLoading = true;
       try {
           await axios.post('/api/client/bulkTransfer', {
               token: localStorage.getItem('jwt'),
               clientIDs: this.selectedClients,
               newAgentID: this.selectedTransferAgentId,
               isProspect: isProspect
           });
           Swal.fire('Success', 'Transfer completed successfully', 'success');
           this.clearSelection();
           
           // Hide modal
           const closeBtn = document.querySelector('#transferModal [data-bs-dismiss="modal"]');
           if (closeBtn) closeBtn.click();
           
           this.updateClientList();
       } catch (error) {
           Swal.fire('Error', 'Transfer failed', 'error');
       }
       this.isLoading = false;
    },

    async bulkChangeStatus() {
      if (this.selectedClients.length === 0) return;

      const { value: statusId } = await Swal.fire({
        title: `Change status for ${this.selectedClients.length} client(s)`,
        input: 'select',
        inputOptions: new Map(this.statusList.map(status => [status.statusID, status.name])),
        inputPlaceholder: 'Select a status',
        showCancelButton: true,
        inputValidator: (value) => {
          if (!value) {
            return 'You need to select a status!'
          }
        }
      });

      if (statusId) {
        const data = {
          token: localStorage.getItem('jwt'),
          clientIDs: this.selectedClients,
          statusID: statusId
        };

        try {
          await axios.post('/api/client/bulkChangeStatus', data);
          await Swal.fire('Updated!', 'Client statuses have been updated.', 'success');
          this.clearSelection();
          this.updateClientList();
        } catch (error) {
          if (error.response && error.response.data.detail === 'Your session is expired!') {
            this.$router.push('logout');
          }
          Swal.fire('Error!', 'Could not update statuses.', 'error');
        }
      }
    },

    async bulkMoveToProspects() {
      if (this.selectedClients.length === 0) return;

      // Fetch Prospect statuses
      let statuses = [];
      try {
        const data = {
          token: localStorage.getItem('jwt'),
          isProspect: 1, // Want prospect statuses
          userEmail: localStorage.getItem('email'),
          userID: localStorage.getItem('id'),
        };
        const response = await axios.post('/api/client/clientStatus', data);
        statuses = response.data;
      } catch (error) {
        console.error("Could not fetch prospect statuses", error);
        Swal.fire('Error', 'Could not fetch prospect statuses.', 'error');
        return;
      }

      const { value: statusId } = await Swal.fire({
        title: `Move ${this.selectedClients.length} client(s) to Prospects?`,
        text: "Select the new status for these prospects:",
        input: 'select',
        inputOptions: new Map(statuses.map(status => [status.statusID, status.name])),
        inputPlaceholder: 'Select a status',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, move them!',
        inputValidator: (value) => {
          if (!value) {
            return 'You need to select a status!'
          }
        }
      });

      if (statusId) {
        const data = {
          token: localStorage.getItem('jwt'),
          clientIDs: this.selectedClients,
          isProspect: 1,  // Move to Prospects
          statusID: statusId
        };

        try {
          await axios.post('/api/client/bulkMove', data);
          await Swal.fire('Moved!', 'Clients have been moved to Prospects.', 'success');
          this.clearSelection();
          this.updateClientList();
        } catch (error) {
        if (error.response && error.response.data.detail === 'Your session is expired!') {
            this.$router.push('logout');
          }
          Swal.fire('Error!', 'Could not move clients.', 'error');
        }
      }
    },

    async openMapModal() {
      if (this.selectedClients.length === 0) {
        Swal.fire('No clients selected', 'Please check at least one client row first.', 'warning');
        return;
      }
      this.mapMarkers = [];
      this.selectedMapMarker = null;
      this.showMapModal = true;
      this.mapIsLoading = true;

      const data = {
        token: localStorage.getItem('jwt'),
        ids: this.selectedClients,
      };

      try {
        const response = await axios.post('/api/client/getClientMapPins', data);
        this.mapMarkers = response.data.map(m => ({
          ...m,
          lat: parseFloat(m.lat),
          lng: parseFloat(m.lng),
        }));

        const skipped = this.selectedClients.length - this.mapMarkers.length;
        if (skipped > 0) {
          Swal.fire({
            toast: true,
            position: 'top-end',
            icon: 'warning',
            title: `${skipped} client(s) have no geocoded address and won't appear on the map.`,
            showConfirmButton: false,
            timer: 4000,
          });
        }
      } catch (err) {
        Swal.fire('Error', 'Could not load map pins. Please try again.', 'error');
        this.showMapModal = false;
      } finally {
        this.mapIsLoading = false;
      }
    },

    closeMap() {
      this.selectedMapMarker = null;
      this.mapMarkers = [];
      this.showMapModal = false;
    },

    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.mobileView = true;
      } else {
        this.mobileView = false;
      }
    },

    async changePage(newPage) {
      if (newPage < 1 || newPage > this.pages.length) return;

      this.page = newPage;
      await this.updateClientList(this.data.searchValues.status, true);
    },

    getMarkerIcon(color) {
      const pinColor = color === 'green' ? '#198754' : (color === 'orange' ? '#fd7e14' : (color === 'yellow' ? '#f39c12' : '#d32f2f'));
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32">
          <path d="M12 0C5.37 0 0 5.37 0 12c0 9 12 20 12 20s12-11 12-20c0-6.63-5.37-12-12-12z" fill="${pinColor}"/>
          <circle cx="12" cy="12" r="4" fill="white" fill-opacity="0.4"/>
        </svg>
      `;
      return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
    },

    prepareBankVerify() {
      if (this.$refs.plaidVerifyModal) {
         this.$refs.plaidVerifyModal.resetForm();
         if (this.clientData && this.clientData.firstName) {
            this.$refs.plaidVerifyModal.form.legalName = this.clientData.firstName + ' ' + (this.clientData.lastName || '');
         }
      }
    },
  },

  async mounted() {
    this.isMobile();
    let field = 'n';
    let url = window.location.href;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const client_id = urlParams.get('client_id');

    if (client_id) {
      // clientlist uses getClientInfo
      await this.getClientInfo(client_id);
      const btn = document.createElement('button');
      btn.style.display = 'none';
      btn.setAttribute('data-bs-toggle', 'modal');
      btn.setAttribute('data-bs-target', '#agentModal');
      document.body.appendChild(btn);
      btn.click();
      document.body.removeChild(btn);
    }

    const status = urlParams.get(field)

    let typeAhead = document.getElementById('typeahead_id')

    const data = {
      token: localStorage.getItem('jwt'),
      searchValues: this.data.searchValues,
      userEmail: localStorage.getItem('email'),
      userID: localStorage.getItem('id'),
      isProspect: 0,
      deleted: 0,
      agentSearch: (typeAhead != null && typeof (typeAhead) != 'undefined') ? typeAhead.value : [],
      page: this.page,
      perPage: this.perPage,
    }

    await axios
        .post('/api/listDepartments', data)
        .then(response => {
          this.departmentList = response.data
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }
            Swal.fire("Oops!", "Departments could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    await axios
        .post('/api/client/clientStatus', data)
        .then(response => {
          this.statusList = response.data
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    await axios
        .post('/api/client/clientTypes', data)
        .then(response => {
          this.typeList = response.data
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail === 'Your session is expired!') {
              this.$router.push('logout')
            }
            Swal.fire("Oops!", "Status could not be loaded, please contact your SysAdmin.", "error")
          }
        })

    if ((url.indexOf('?' + field + '=') !== -1))
      document.getElementById(status).click()
    else
      await axios
          .post('/api/client/listClients', data)
          .then(response => {
            this.list = response.data.results;
            this.page = response.data.page;
            this.listQty = response.data.total;
            this.setPages();
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail === 'Your session is expired!') {
                this.$router.push('logout')
              }
            } else if (error.message) {
              this.errors.push('Something was wrong, please contact your SysAdmin.')
            }
          })

    const checkAll = document.getElementById("checkAll");

    if (checkAll) {
      checkAll.onclick = function () {
        var checkboxes = document.querySelectorAll(
            '.form-check-all input[type="checkbox"]'
        );
        if (checkAll.checked == true) {
          checkboxes.forEach(function (checkbox) {
            checkbox.checked = true;
            checkbox.closest("tr").classList.add("table-active");
          });
        } else {
          checkboxes.forEach(function (checkbox) {
            checkbox.checked = false;
            checkbox.closest("tr").classList.remove("table-active");
          });
        }
      };
    }

    function addEvent(parent, evt, selector, handler) {
      parent.addEventListener(evt, function (event) {
        if (event.target.matches(selector + ', ' + selector + ' *')) {
          handler.apply(event.target.closest(selector), arguments);
        }
      }, false);
    }

    addEvent(document, 'click', 'button.removeItemBen', function () {
      let button_id = this.id;
      document.getElementById('rowBen' + button_id).remove();
    });
    addEvent(document, 'click', 'button.removeItemEcon', function () {
      let button_id = this.id;
      document.getElementById('rowEcon' + button_id).remove()
    });
    addEvent(document, 'click', 'button.removeItemAdditaments', function () {
      let button_id = this.id;
      document.getElementById('rowAdditaments' + button_id).remove()
    });

    this.agentVisible = !!(this.viewUserGroup('SUPER_ADMIN_GROUP') || this.viewUserGroup('ADMIN_GROUP'));

      document.querySelectorAll(".checkout-tab").forEach(function (form) {
        form.querySelectorAll(".nexttab").forEach(function (nextButton) {
          var tabEl = form.querySelectorAll('button[data-bs-toggle="pill"]');
          tabEl.forEach(function (item) {
            item.addEventListener("show.bs.tab", function (event) {
              event.target.classList.add("done");
            });
          });
          nextButton.addEventListener("click", function () {
            var nextTab = nextButton.getAttribute("data-nexttab");
            document.getElementById(nextTab).click();
          });
        });

        form.querySelectorAll(".previestab").forEach(function (prevButton) {
          prevButton.addEventListener("click", function () {
            var prevTab = prevButton.getAttribute("data-previous");
            var totalDone = prevButton
                .closest("form")
                .querySelectorAll(".custom-nav .done").length;
            for (var i = totalDone - 1; i < totalDone; i++) {
              prevButton.closest("form").querySelectorAll(".custom-nav .done")[i]
                  ? prevButton
                      .closest("form")
                      .querySelectorAll(".custom-nav .done")[i].classList.remove("done")
                  : "";
            }
            document.getElementById(prevTab).click();
          });
        });

        var tabButtons = form.querySelectorAll('button[data-bs-toggle="pill"]');
        tabButtons.forEach(function (button, i) {
          button.setAttribute("data-position", i);
          button.addEventListener("click", function () {
            form.querySelectorAll(".custom-nav .done").length > 0
                ? form
                    .querySelectorAll(".custom-nav .done")
                    .forEach(function (doneTab) {
                      doneTab.classList.remove("done");
                    })
                : "";
            for (var j = 0; j <= i; j++) {
              tabButtons[j].classList.contains("active")
                  ? tabButtons[j].classList.remove("done")
                  : tabButtons[j].classList.add("done");
            }
          });
        });
      });
    },

  computed: {
    hasCallupUsername() {
      return !!localStorage.getItem('callupUsername');
    },
    selectedClientsData() {
      return this.selectedClientObjects;
    },
    canTransfer() {
      return this.viewUserGroup ? this.viewUserGroup('SUPER_ADMIN_GROUP') : false;
    },
    canVerifyBank() {
      const isSuperAdmin = this.viewUserGroup ? this.viewUserGroup('SUPER_ADMIN_GROUP') : false;
      const deptId = localStorage.getItem('departmentID');
      return isSuperAdmin || deptId == '24';
    },
    sourceOptions() {
      if (!this.typeList) return [];
      const list = Array.isArray(this.typeList) ? this.typeList : Object.values(this.typeList);
      return list.filter(t => t && t.name).map(t => ({ value: t.name, label: t.name }));
    },
    statusOptions() {
      if (!this.statusList) return [];
      const list = Array.isArray(this.statusList) ? this.statusList : Object.values(this.statusList);
      return list.filter(s => s && s.name && s.statusID !== undefined).map(s => ({ value: String(s.statusID), label: s.name }));
    },

    displayedPosts() {
      return Array.isArray(this.list) ? this.list : [];
    },

    resultQuery() {
      if (this.data.searchValues.keyword.length >= 3) {
        const search = this.data.searchValues.keyword.toLowerCase();
        return this.displayedPosts.filter((data) => {
          return (
              (data.FullName || '').toLowerCase().includes(search) ||
              (data.email || '').toLowerCase().includes(search) ||
              (data.phoneNumber || '').toLowerCase().includes(search) ||
              (data.firstName || '').toLowerCase().includes(search) ||
              (data.lastName || '').toLowerCase().includes(search) ||
              (data.postalCode || '').toLowerCase().includes(search)
          );
        });
      } else {
        return this.displayedPosts;
      }
    },

    visiblePages() {
      const total = this.pages.length;
      const current = this.page;
      const delta = 2;
      const pages = [];

      if (total <= 7) return this.pages;

      let start = Math.max(1, current - delta);
      let end = Math.min(total, current + delta);

      if (current <= 3) {
        start = 1;
        end = 5;
      }

      if (current >= total - 2) {
        start = total - 4;
        end = total;
      }

      for (let i = start; i <= end; i++) pages.push(i);

      return pages;
    },
  },

  setup() {
    let files = ref([]);
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0];
      files.value.push(dropzoneFile.value);
    };
    const selectedFileLegacy = () => {
      dropzoneFile.value = document.getElementById('listFile').files[0];
      files.value.push(dropzoneFile.value);
    };
    watch(
        () => [...files.value],
        (currentValue) => {
          return currentValue;
        }
    );
    return {
      dropzoneFile,
      drop,
      selectedFileLegacy,
      v$: useVuelidate(),
      files,
    };
  },
};
</script>

<style>
/* Style the image */
#myImage {
  border-radius: 5px;
  cursor: pointer;
}

.blink {
  animation: blink-animation 1.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 1.5s steps(5, start) infinite;
}
@keyframes blink-animation {
  to { visibility: hidden; }
}
@-webkit-keyframes blink-animation {
  to { visibility: hidden; }
}

/* Hide the modal by default */
.modal-preview {
  display: none;
  position: fixed;
  z-index: 1;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.4);
}

/* Modal Content (Image) */
.modal-content-preview {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Close Button */
.close {
  color: #fff;
  font-size: 30px;
  position: absolute;
  top: 15px;
  right: 35px;
  cursor: pointer;
}

/* Add animation */
.modal-content-preview, .close {
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {transform: scale(0)}
  to {transform: scale(1)}
}

[data-title]:hover:after {
  opacity: 1;
  transition: all 0.1s ease 0.5s;
  visibility: visible;
}
[data-title]:after {
  content: attr(data-title);
  position: absolute;
  bottom: -1.6em;
  left: 100%;
  padding: 4px 4px 4px 8px;
  color: #222;
  white-space: nowrap;
  border-radius: 5px;
  box-shadow: 0px 0px 4px #222;
  background-image: linear-gradient(to bottom, #f8f8f8, #cccccc);
  opacity: 0;
  z-index: 99999;
  visibility: hidden;
}
[data-title] {
  position: relative;
}

.blink {
  animation: blink-animation 1.5s steps(5, start) infinite;
  -webkit-animation: blink-animation 1.5s steps(5, start) infinite;
}
@keyframes blink-animation {
  to { visibility: hidden; }
}
@-webkit-keyframes blink-animation {
  to { visibility: hidden; }
}

/* === Inline Map Modal === */
/* Button toolbar: full-width on mobile, auto on ≥768px */
.btn-bar { width: 100%; }
@media (min-width: 768px) {
  .btn-bar { width: auto !important; }
}

.map-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1049;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.map-modal-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff;
}

.map-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  flex-shrink: 0;
}

.map-modal-loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.map-modal-body {
  flex: 1;
  overflow: hidden;
}
</style>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <loader v-if="isLoading" :isLoading="isLoading" />

    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="leadsList">
          <div class="card-header">
            <div class="d-flex align-items-center flex-wrap gap-2">
              <div class="flex-grow-1">
                <div class="row">
                  <div class="col-xxl-4 col-sm-4" style="margin-bottom: 5px;">
                    <div class="search-box">
                      <input
                          type="text"
                          class="form-control search"
                          placeholder="Search for..."
                          title="Search by (Phone number, City, Postal code, Name, Last name, Full Name, Address, State)"
                          v-model="data.searchValues.keyword"
                          @change="data.searchValues.keyword.length >= 3 ? updateClientList(): ''"
                          v-on:keyup.enter="data.searchValues.keyword === '' ? updateClientList() : ''"
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>

                  <div class="col-xxl-4 col-sm-4" style="margin-bottom: 5px;">
                    <div class="d-flex align-items-center gap-2">
                      <span class="text-muted flex-shrink-0">Sort by: </span>

                      <Multiselect class="form-control"
                                   style="padding: 0px;"
                                   @focus="handleFocus"
                                   v-model="data.searchValues.sortBy"
                                   :close-on-select="true"
                                   :searchable="true"
                                   :options="[
                            { value: 'name', label: 'Name' },
                            { value: 'lastName', label: 'Last Name' },
                            { value: 'postalCode', label: 'Postal Code' },
                            { value: 'modified', label: 'Modified On' },
                            { value: 'created', label: 'created On' },
                            ]"
                                   @select="updateClientList()"
                      />

                    </div>
                  </div>

                  <div class="col-xxl-4 col-sm-4" style="margin-bottom: 5px;">
                    <div class="d-flex align-items-center gap-2">
                      <span class="text-muted flex-shrink-0">Order by: </span>

                      <Multiselect class="form-control"
                                   style="padding: 0px;"
                                   v-model="data.searchValues.orderBy"
                                   @focus="handleFocus"
                                   :close-on-select="true"
                                   :searchable="true"
                                   :options="[
                            { value: 'ASC', label: 'Ascendance' },
                            { value: 'DESC', label: 'Descendant' },
                            ]"
                                   @select="updateClientList()"
                      />

                    </div>
                  </div>
                </div>
              </div>
              <div class="btn-bar">
                <div class="d-flex flex-wrap gap-2 align-items-center">
                  <button type="button" class="btn btn-soft-success" href="#open-filters" data-bs-toggle="modal">
                    <i class="ri-filter-line align-bottom"></i>
                    <span class="d-none d-sm-inline ms-1">Filters</span>
                  </button>
                  <button type="button" class="btn btn-soft-success" id="create-btn" data-bs-toggle="modal" href="#agentModal" @click="addNewAgentModal">
                    <i class="ri-add-line align-bottom"></i>
                    <span class="d-none d-sm-inline ms-1">Add Client</span>
                  </button>

                  <!-- Bulk Action Buttons - Only show when items are selected -->
                  <template v-if="selectedClients.length > 0">
                    <button type="button" class="btn btn-danger" @click="bulkDelete" :title="'Delete ' + selectedClients.length + ' selected'">
                      <i class="ri-delete-bin-line align-bottom"></i>
                      <span class="d-none d-sm-inline ms-1">Delete ({{selectedClients.length}})</span>
                      <span class="d-inline d-sm-none ms-1">{{selectedClients.length}}</span>
                    </button>
                    <button type="button" class="btn btn-warning" @click="bulkChangeStatus" title="Change status">
                      <i class="ri-refresh-line align-bottom"></i>
                      <span class="d-none d-sm-inline ms-1">Change Status</span>
                    </button>
                    <button type="button" class="btn btn-primary" @click="bulkMoveToProspects" title="Move to Prospects">
                      <i class="ri-arrow-right-line align-bottom"></i>
                      <span class="d-none d-sm-inline ms-1">To Prospects</span>
                    </button>
                    <button type="button" class="btn btn-secondary" v-if="canTransfer" data-bs-toggle="modal" data-bs-target="#transferModal" @click="openTransferModal" title="Transfer to Agent">
                      <i class="ri-user-shared-line align-bottom"></i>
                      <span class="d-none d-sm-inline ms-1">Transfer ({{selectedClients.length}})</span>
                    </button>
                    <button type="button" class="btn btn-soft-info" @click="openMapModal" title="Show selected clients on map">
                      <i class="ri-map-pin-line align-bottom"></i>
                      <span class="d-none d-sm-inline ms-1">Map ({{ selectedClients.length }})</span>
                    </button>
                  </template>

                  <button
                      type="button"
                      id="dropdownMenuLink1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      class="btn btn-info text-white"
                  >
                    <i class="ri-more-2-fill"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                    <li><a class="dropdown-item" href="#uploadLeads" data-bs-toggle="modal">Upload Clients</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Table Head -->
          <div class="d-flex flex-wrap gap-2 align-items-center mb-3">
            <!-- Status tabs — scrollable on mobile, inline on desktop -->
            <div style="overflow-x: auto; -webkit-overflow-scrolling: touch; flex: 1 1 auto; min-width: 0;">
              <ul
                  class="nav nav-tabs nav-tabs-custom nav-primary mb-0 flex-nowrap"
                  role="tablist"
                  style="min-width: max-content;">
                <li class="nav-item">
                  <a
                      class="nav-link active All py-3"
                      data-bs-toggle="tab"
                      id="All"
                      href="#home1"
                      role="tab"
                      aria-selected="true"
                      @click="updateClientList(0)"
                  >
                    <i class="ri-file-search-line me-1 align-bottom"></i> All
                  </a>
                </li>
                <li class="nav-item" v-for="(data, index) of statusList" :key="index">
                  <a
                      class="nav-link py-3 " v-bind:class="data.name"
                      data-bs-toggle="tab"
                      v-bind:id="data.name"
                      v-bind:href="'#'+data.name"
                      role="tab"
                      aria-selected="false"
                      @click="updateClientList(data.statusID)"
                  >
                    <i class="me-1 align-bottom"></i>
                    {{ data.name }}
                  </a>
                </li>
              </ul>
            </div>

            <!-- Verify Phone — wraps below tabs on mobile, inline on desktop -->
            <div class="d-flex gap-2 align-items-center flex-shrink-0 ms-auto me-1" style="width: auto;">
              <input type="text" class="form-control" style="min-width: 120px; max-width: 180px;" placeholder="Verify Phone" v-model="phoneVerification">
              <button type="button" class="btn btn-soft-primary" @click="verifyPhone">
                Check
              </button>
            </div>
          </div>
          <div class="card-body">
            <span v-if="mobileView === false">
              <div class="table-responsive table-card mb-4">
                <table class="table align-middle table-nowrap mb-0">
                              <thead class="table-light">
                              <tr>
                                <th scope="col" style="width: 50px">
                                  <div class="form-check">
                                     <input
                                         class="form-check-input"
                                         type="checkbox"
                                         id="checkAll"
                                         @change="toggleSelectAll"
                                     />
                                  </div>
                                </th>
                                <th scope="col">Name</th>
                                <th scope="col" v-if="agentVisible">Department</th>
                                <th scope="col">Email</th>
                                <th scope="col">Zip Code</th>
                                <th scope="col">Phone</th>
                                <th scope="col">Create Date</th>
                                <th scope="col" v-if="Array.isArray(this.data.searchValues.status) ? this.data.searchValues.status.includes('2') : this.data.searchValues.status === '2'">Appmnt D.</th>
                                <th scope="col">Status</th>
                                <th scope="col">Actions</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr v-for="data of resultQuery" :key="data.ID">
                                <td>
                                   <div class="form-check">
                                     <input 
                                       class="form-check-input" 
                                       type="checkbox" 
                                       :checked="isClientSelected(data.ID)"
                                       @change="toggleClient(data.ID)"
                                     >
                                   </div>
                                </td>
                                 <td>
                                   <div class="d-flex align-items-center">
                                     <span 
                                       v-if="data.markerColor" 
                                       class="me-2" 
                                       :style="{ 
                                         width: '10px', 
                                         height: '10px', 
                                         borderRadius: '50%', 
                                         backgroundColor: data.markerColor === 'green' ? '#198754' : (data.markerColor === 'orange' ? '#fd7e14' : (data.markerColor === 'yellow' ? '#ffc107' : '#b02a37')),
                                         display: 'inline-block',
                                         flexShrink: '0'
                                       }"
                                       :title="data.markerColor === 'green' ? 'Visited Recently' : (data.markerColor === 'orange' ? 'Visited \u2013 No Response' : (data.markerColor === 'yellow' ? 'Needs Follow-up' : 'Visit Overdue'))"
                                     ></span>
                                     {{ data.firstName }} {{ data.lastName }}
                                   </div>
                                 </td>
                                <td v-if="agentVisible">{{ data.departmentName }}</td>
                                <td>{{ data.email }}</td>
                                <td>{{ data.postalCode }}</td>
                                <td>
                                  {{ formatPhone(data.phoneNumber) }}
                                  <span v-if="data.donotcall === 1" class="badge badge-soft-danger blink ms-1">Do Not Call</span>
                                </td>
                                <td> {{ formatDateCT(data.createdOn) }} </td>
                                <td v-if="Array.isArray(this.data.searchValues.status) ? this.data.searchValues.status.includes('2') : this.data.searchValues.status === '2'">{{ formatDateCT(data.interviewDate)  }}</td>
                                <td><a href="javascript:void(0);" v-bind:style="'color:'+data.colors"  @click="filterStatus(data.statusName)">{{ data.statusName}}</a></td>
                                  <td>
                                    <ul class="list-inline hstack gap-2 mb-0">
                                      <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Edit">
                                        <a class="btn btn-sm btn-soft-info edit-item-btn" href="#agentModal" data-bs-toggle="modal" @click="getClientInfo(data.ID)">
                                          <i class="ri-pencil-fill align-bottom fs-16"></i>
                                        </a>
                                      </li>
                                      <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Notes">
                                        <a href="#open-notes" class="btn btn-sm btn-soft-warning d-inline-block" data-bs-toggle="modal" @click="getNotes(data.ID)">
                                          <i class="ri-sticky-note-fill align-bottom fs-16"></i>
                                        </a>
                                      </li>
                                      <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Messages" v-if="agentVisible">
                                        <a href="#open-messages" class="btn btn-sm btn-soft-warning d-inline-block" data-bs-toggle="modal" @click="getSMS(data.ID)">
                                          <i class="ri-mail-send-fill align-bottom fs-16"></i>
                                        </a>
                                      </li>
                                      <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Update Status">
                                        <a class="btn btn-sm btn-soft-success edit-item-btn" href="#changeStatus" data-bs-toggle="modal" @click="getProspectStatus(data.ID)">
                                          <i class="ri-refresh-fill align-bottom fs-16"></i>
                                        </a>
                                      </li>
                                      <li class="list-inline-item" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-placement="top" title="Delete">
                                        <a class="btn btn-sm btn-soft-danger remove-item-btn" data-bs-toggle="modal" href="javascript:void(0);" @click="deleteClient(data.ID)">
                                          <i class="ri-delete-bin-fill align-bottom fs-16"></i>
                                        </a>
                                      </li>
                                    </ul>
                                  </td>
                              </tr>
                              </tbody>
                            </table>
                <!--end table-->
            </div>
            </span>
            <span v-else>
            <div class="table-responsive">
              <table class=" table table-hover align-middle  mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th scope="col">
                    <div class="d-flex align-items-center gap-2 justify-content-center">
                      <div class="form-check mb-0">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="checkAllMobile"
                          :checked="selectedClients.length === resultQuery.length && resultQuery.length > 0"
                          @change="toggleSelectAll"
                        />
                      </div>
                      <span>CARDS</span>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data of resultQuery" :key="data.ID">
                  <td>
                    <div class="collapse show" :id="'leadDiscovered1'+data.ID">
                        <div class="card mb-1">
                            <div class="card-body" style=" padding: 10px 10px 10px 5px !important;">
                                <div class="d-flex align-items-center">
                                    <!-- Selection checkbox -->
                                    <div class="flex-shrink-0 me-2" @click.stop>
                                      <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :checked="isClientSelected(data.ID)"
                                        @change="toggleClient(data.ID)"
                                        style="width: 18px; height: 18px; cursor: pointer; margin-top: 0;"
                                      />
                                    </div>
                                    <!-- Collapse toggle -->
                                    <a class="d-flex align-items-center flex-grow-1" data-bs-toggle="collapse"
                                       :href="'#leadDiscovered'+data.ID" role="button" aria-expanded="false"
                                       :aria-controls="'leadDiscovered'+data.ID">
                                        <div class="flex-shrink-0">
                                            <img src="@/assets/images/logo-circle-white.png" alt="" class="avatar-xs rounded-circle"/>
                                        </div>
                                        <div class="flex-grow-1 ms-3">
                                            <h6 class="fs-14 mb-1">
                                              <span
                                                v-if="data.markerColor"
                                                class="me-1"
                                                :style="{
                                                  width: '8px',
                                                  height: '8px',
                                                  borderRadius: '50%',
                                                  backgroundColor: data.markerColor === 'green' ? '#198754' : (data.markerColor === 'orange' ? '#fd7e14' : (data.markerColor === 'yellow' ? '#ffc107' : '#b02a37')),
                                                  display: 'inline-block',
                                                  verticalAlign: 'middle',
                                                  marginTop: '-2px',
                                                  flexShrink: '0'
                                                }"
                                              ></span>
                                              {{ data.FullName }}
                                            </h6>
                                            <p class="text-muted mb-0" v-if="agentVisible">{{ data.departmentName }}</p>
                                            <p class="text-muted mb-0">{{ data.statusName }}</p>
                                            <p class="text-muted mb-0" v-if="Array.isArray(this.data.searchValues.status) ? this.data.searchValues.status.includes('2') : this.data.searchValues.status === '2'">{{ data.statusName }}</p>
                                            <p class="text-muted mb-0">{{ data.email.substring(0, 30) }}</p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <div class="collapse border-top border-top-dashed" :id="'leadDiscovered'+data.ID">
                                <div class="card-body">
                                    <h6 class="fs-14 mb-1"><small class="badge badge-soft-primary">{{ data.labelName }}</small></h6>
                                    <ul class="list-unstyled vstack gap-2 mb-0">
                                        <li>
                                            <div class="d-flex">
                                                <div class="flex-shrink-0 avatar-xxs text-muted">
                                                    <i class="ri-phone-fill"></i>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h6 class="mb-0">Phone Number</h6>
                                                    <small class="text-muted"> {{ data.phoneNumber }}</small>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="d-flex">
                                                <div class="flex-shrink-0 avatar-xxs text-muted">
                                                    <i class="ri-mail-fill"></i>
                                                </div>
                                                <div class="flex-grow-1">
                                                    <h6 class="mb-0">Email</h6>
                                                    <small class="text-muted">{{ data.email }}</small>
                                                </div>
                                            </div>
                                        </li>
                                      <li>
                                            <div class="d-flex">
                                                <div class="flex-shrink-0 avatar-xxs text-muted">
                                                    <i class="ri-calendar-2-fill"></i>
                                                </div>
                                                <div class="flex-grow-s1">
                                                    <h6 class="mb-0">Created On</h6>
                                                    <small class="text-muted">{{ formatDateCT(data.createdOn) }}</small>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div class="card-footer hstack gap-2">
                                  <div class="row">
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-primary btn-sm w-100 edit-item-btn" data-bs-toggle="modal"
                                              data-bs-trigger="hover" data-bs-placement="top" title="Edit"
                                              @click="getClientInfo(data.ID)" href="#agentModal">
                                        <i class="ri-pencil-fill align-bottom me-1"></i> Edit
                                      </button>
                                    </div>
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-primary btn-sm w-100"
                                              data-bs-trigger="hover" data-bs-placement="top" title="Call">
                                          <i class="ri-phone-fill align-bottom me-1"></i>
                                          <a :href="'tel:'+data.phone" style="color: white"> Make Call </a>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-success btn-sm w-100"
                                              data-bs-trigger="hover" data-bs-placement="top" title="Update Status"
                                              data-bs-toggle="modal"
                                              href="#changeStatus"
                                              @click="getProspectStatus(data.ID)">
                                          <i class="ri-refresh-fill align-bottom me-1"></i> Update Status
                                      </button>
                                    </div>
                                    <div class="col-md-6" style="margin-bottom: 5px;">
                                      <button class="btn btn-danger btn-sm w-100"
                                              data-bs-trigger="hover" data-bs-placement="top" title="Delete" @click="deleteClient(data.ID)">
                                          <a class="remove-item-btn" data-bs-toggle="modal" href="javascript:void(0);" style="color: white;">
                                           <i class="ri-delete-bin-fill align-bottom me-1"></i>
                                            Delete
                                          </a>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div><!--end card-->
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            </span>
            <div class="noresult" v-if="list.length <= 0">
              <div class="text-center">
                <lottie
                    class="avatar-xl"
                    colors="primary:#121331,secondary:#08a88a"
                    :options="defaultOptions"
                    :height="75"
                    :width="75"
                />
                <h5 class="mt-2">Sorry! No Result Found</h5>
                <p class="text-muted mb-0">
                  We've searched and didn't find any
                  Work Order for you.
                </p>
              </div>
            </div>
            <div class="table-responsive">
              <div class="d-flex justify-content-end mt-3" v-if="listQty > 0">
                <div class="pagination-wrap hstack gap-2">
                  <a
                      class="page-item pagination-prev"
                      href="#"
                      v-if="page > 1"
                      @click.prevent="changePage(page - 1)"
                  >
                    Previous
                  </a>
                  <ul class="pagination listjs-pagination mb-0">
                    <!-- Primera página -->
                    <li v-if="pages.length > 0 && page > 3">
                      <a class="page" href="#" @click.prevent="changePage(1)">1</a>
                    </li>

                    <!-- … antes -->
                    <li v-if="page > 4">
                      <span class="page">...</span>
                    </li>

                    <!-- Páginas centradas -->
                    <li
                        v-for="(pageNumber, index) in visiblePages"
                        :key="index"
                        :class="{ active: pageNumber === page }"
                    >
                      <a class="page" href="#" @click.prevent="changePage(pageNumber)">
                        {{ pageNumber }}
                      </a>
                    </li>

                    <!-- … después -->
                    <li v-if="page < pages.length - 3">
                      <span class="page">...</span>
                    </li>

                    <!-- Última página -->
                    <li v-if="pages.length > 1 && page < pages.length - 2">
                      <a class="page" href="#" @click.prevent="changePage(pages.length)">
                        {{ pages.length }}
                      </a>
                    </li>
                  </ul>
                  <a
                      class="page-item pagination-next"
                      href="#"
                      v-if="page < pages.length"
                      @click.prevent="changePage(page + 1)"
                  >
                    Next
                  </a>
                  <span>
                  Prospects Found: <b>{{ listQty }}</b>
                </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <!--  Add client modal  -->
    <div class="modal zoomIn" id="agentModal" tabindex="-1" aria-labelledby="agentModalLabel" aria-hidden="true" data-bs-focus="false">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 1000px;">
        <div class="modal-content">
          <div class="modal-header bg-light p-3">
            <h5 class="modal-title d-flex align-items-center" id="agentModalLabel">
              {{ modalFormTitle }}
              <template v-if="clientData.markerColor">
                <div class="dropdown d-inline-block ms-2">
                  <span v-if="clientData.markerColor === 'green'" class="badge bg-success dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer;" title="Visited Recently">🟢 Visited Recently</span>
                  <span v-else-if="clientData.markerColor === 'orange'" class="badge dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer; background-color: #fd7e14; color: white;" title="Visited &ndash; No Response">🟠 Visited &ndash; No Response</span>
                  <span v-else-if="clientData.markerColor === 'yellow'" class="badge bg-warning text-dark dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer;" title="Needs Follow-up">🟡 Needs Follow-up</span>
                  <span v-else-if="clientData.markerColor === 'red' && (!clientData.lastVisitDate || clientData.lastVisitDate === 'Never')" class="badge bg-danger dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer;" title="Never Visited">🔴 Never Visited</span>
                  <span v-else-if="clientData.markerColor === 'red'" class="badge bg-danger dropdown-toggle" data-bs-toggle="dropdown" style="cursor: pointer;" title="Visit Overdue">🔴 Visit Overdue</span>
                  
                  <ul class="dropdown-menu">
                    <li v-if="clientData.markerColor !== 'green'"><a class="dropdown-item" href="#" @click.prevent="markVisited(clientData.ID)">🟢 Mark Visited</a></li>
                    <li v-if="clientData.markerColor !== 'orange'"><a class="dropdown-item" href="#" @click.prevent="markVisitPending(clientData.ID)">🟠 Mark Visited &ndash; No Response</a></li>
                  </ul>
                </div>
              </template>
            </h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    id="close-modal"></button>
          </div>
          <form id="addform" @submit.prevent="" autocomplete="off">
            <div class="modal-body">
              <h6> <span style="color:red; font-size: 0.7em;">Required fields (*)</span></h6>
              <input type="hidden" id="id"/>
              <div class="row g-3">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-7">
                      <label for="editEmail" class="form-label">Email</label>
                      <input type="text" id="editEmail" name="editEmail" class="form-control mb-2 createEmail" placeholder="Enter Email"
                             v-model="clientData.email" autocomplete="new-password">
                      <div class="invalid-feedback">
                        This email is already in use.
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <label for="editCreatedBy" class="form-label">Created By</label>
                      <input type="text" id="editCreatedBy" name="editCreatedBy" class="form-control mb-2" disabled v-model="clientData.createdBy"  autocomplete="off">
                    </div>
                    <div class="col-lg-2">
                      <label for="editLastVisit" class="form-label">Last Visit</label>
                      <input type="text" id="editLastVisit" name="editLastVisit" class="form-control mb-2" disabled :value="clientData.lastVisitDate ? formatDate(clientData.lastVisitDate, 'DD MMM, YYYY') : 'Never'" autocomplete="off">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label for="editFirstName" class="form-label">First Name <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <input type="text" id="editFirstName" name="editFirstName" class="form-control mb-2" placeholder="Enter First Name" v-model="clientData.firstName" required  autocomplete="new-password">
                    </div>
                    <div class="col-lg-4">
                      <label for="editLastName" class="form-label">Last Name <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <input type="text" id="editLastName" name="editLastName" class="form-control mb-2" placeholder="Enter Last Name" v-model="clientData.lastName" required  autocomplete="new-password">
                    </div>
                    <div class="col-lg-4">
                      <label for="editGender" class="form-label"> Gender <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <br>
                      <div class="form-check-success form-check-inline" style="margin-top: 0.8em;">
                        <input class="form-check-input" type="radio" name="editGender" id="editGender" value="M" v-model="clientData.gender"/>
                        <label class="form-check-label" for="editGender"> &nbsp; Male</label>
                      </div>
                      <div class="form-check-success form-check-inline" style="margin-top: 0.8em;">
                        <input class="form-check-input" type="radio" name="editGender" id="editGender2" value="F" v-model="clientData.gender"/>
                        <label class="form-check-label" for="editGender2"> &nbsp; Female</label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label for="editLanguage" class="form-label">Language <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Language" id="editLanguage" name="editLanguage" v-model="clientData.language" required>
                        <option value="1" selected>English</option>
                        <option value="2">Spanish</option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label for="editStatus" class="form-label">Status <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Status" id="editStatus" name="editStatus" v-model="clientData.status">
                        <option v-for="(status, statusIndex) of statusList" :key="statusIndex" v-bind:value="status.statusID">{{ status.name }}</option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label for="editType" class="form-label">client Source <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Status" id="editType" name="editType" v-model="clientData.leadType">
                        <option v-for="(type, typeIndex) of typeList" :key="typeIndex" v-bind:value="type.name">{{ type.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label for="editPhoneNumber" class="form-label">Phone <span style="color:red; font-size: 0.7em;">(*)</span></label>&nbsp;<span class="badge badge-pill bg-danger blink" data-key="t-new" v-if="openCreate == 0 && clientData.donotcall === 1"> Do not call</span>
                      <div class="input-group mb-2">
                        <input type="text" id="editPhoneNumber" name="editPhoneNumber" class="form-control" placeholder="Phone number" required v-model="clientData.phoneNumber" autocomplete="new-password"/>
                        <ClickToCallButton v-if="hasCallupUsername" :phone-number="clientData.phoneNumber" />
                      </div>
                    </div>
                    <div class="col-lg-4">
                      <label for="editDepartment" class="form-label">Department <span style="color:red; font-size: 0.7em;">(*)</span></label>
                      <select class="form-select mb-2" aria-label="Department" id="editDepartment" name="editDepartment"
                              v-model="clientData.departmentID" v-if="(departmentList.length > 1)">
                        <option v-for="(department, index) of departmentList"  :key="index"
                                v-bind:value="department.departmentID">{{ department.name }}
                        </option>
                      </select>
                      <select class="form-select mb-2" aria-label="Department" id="editDepartment" name="editDepartment"
                              v-model="clientData.departmentID" v-else>
                        <option v-bind:value="departmentList.departmentID">{{ departmentList.name }}</option>
                      </select>
                    </div>
                    <div class="col-lg-4">
                      <label for="editInterview" class="form-label mb-2">Interview</label>
                      <flat-pickr
                          v-model="clientData.interview"
                          :config="dateTimeConfig"
                          id="editInterview"
                          name="editInterview"
                          class="form-control"
                          data-provider="timepickr"
                          data-time-hrs="true"
                      ></flat-pickr>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-8">
                      <label for="editAddress" class="form-label">Address</label>&nbsp;<code><a href="#" target="_blank" id="gMapsLink">Google Maps</a></code>
                      <input type="text" id="editAddress" name="editAddress" class="form-control mb-2" placeholder="Enter Address" required v-model="clientData.address" autocomplete="new-password"/>
                    </div>
                    <div class="col-lg-3">
                      <label for="editBirthdate" class="form-label"> Birthdate <span style="color:red; font-size: 0.7em;">(*)</span> </label>
                      <flat-pickr
                          v-model="clientData.birthday"
                          :config="timeConfig"
                          class="form-control flatpickr-input"
                          id="editBirthdate"
                          name="editBirthdate"
                      ></flat-pickr>
                    </div>
                    <div class="col-lg-1">
                      <label for="editAgeInput" class="form-label">Age</label>
                      <input type="number" id="editAgeInput" name="editAgeInput" class="form-control" v-model="clientData.age" @input="clientData.age_source = 'Manual'" placeholder="Age">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3">
                      <label for="editState" class="form-label">State</label>
                      <input type="text" id="editState" name="editState" class="form-control mb-2" placeholder="Enter State" required v-model="clientData.state" autocomplete="new-password"/>
                    </div>
                    <div class="col-lg-5">
                      <label for="editCity" class="form-label">City</label>
                      <input type="text" id="editCity" name="editCity" class="form-control mb-2" placeholder="Enter City" required v-model="clientData.city" autocomplete="new-password"/>
                    </div>
                    <div class="col-lg-4">
                      <label for="editPostalCode" class="form-label">Zip code</label>
                      <input type="text" id="editPostalCode" name="editPostalCode" class="form-control mb-2" placeholder="Enter Zip code" required v-model="clientData.postalCode" autocomplete="new-password"/>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-4">
                      <label for="editPolicyNumber" class="form-label">Policy Number</label>
                      <input type="text" id="editPolicyNumber" name="editPolicyNumber" class="form-control mb-2" placeholder="Enter Policy Number" v-model="clientData.policyNumber" autocomplete="off"/>
                    </div>
                  </div>
                  <div class="row" v-if="openCreate === 1">
                    <div class="mt-4">
                      <label
                          for="editNotes"
                          class="form-label text-muted text-uppercase fw-semibold"
                      >Notes</label>
                      <textarea
                          class="form-control alert alert-primary"
                          v-model="clientData.note"
                          id="editNotes"
                          name="editNotes"
                          placeholder="Notes"
                          rows="2"
                      ></textarea>
                    </div>
                  </div >
                  <div class="row" v-if="openCreate === 1">
                    <!-- Add beneficiaries -->
                    <fieldset class="fieldset-style">
                      <legend class="legend-style"><small style="font-size: 0.7em;">Add Beneficiary <b>+</b></small> <span class="btn btn-success" @click="addBeneficiary()" style="float: right;"><i class="ri-add-line"></i></span>
                        <hr></legend>
                      <div class="form-group">
                        <div id="addBeneficiary">
                        </div>
                      </div>
                    </fieldset>

                    <!-- Add Emergency contacts -->
                    <fieldset class="fieldset-style">
                      <legend class="legend-style"><small style="font-size: 0.7em;">Emergency Contacts <b>+</b></small> <span class="btn btn-success" @click="addEcontact()" style="float: right;"><i class="ri-add-line"></i></span><hr></legend>
                      <div class="form-group">
                        <form id="addEcontact">
                        </form>
                      </div>
                    </fieldset>

                    <!-- Add Additaments -->
                    <fieldset class="fieldset-style">
                      <legend class="legend-style"><small style="font-size: 0.7em;">Add Additaments <b>+</b></small> <span class="btn btn-success" @click="addAdditaments()" style="float: right;"><i class="ri-add-line"></i></span><hr></legend>
                      <div class="form-group">
                        <form id="addAdditaments">
                        </form>
                      </div>
                    </fieldset>
                  </div>

                  <div class="row" v-if="openCreate == 0">
                    <div class="row">
                      <div class="col-xl-12" style="margin-top: 10px;">
                        <div class="card">
                          <div class="card-body checkout-tab">
                            <form action="#">
                              <div class="step-arrow-nav mt-n3 mx-n3 mb-3">
                                <ul class="nav nav-pills nav-justified custom-nav" role="tablist">
                                  <li class="nav-item" role="presentation">
                                    <button
                                        class="nav-link fs-15 p-3 active"
                                        id="pills-bill-notes-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pills-notes"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-pills-notes"
                                        aria-selected="true"
                                    >
                                      <i
                                          class="
                                        ri-sticky-note-line
                                        fs-16
                                        p-2
                                        bg-soft-primary
                                        text-primary
                                        rounded-circle
                                        align-middle
                                        me-2
                                      "
                                      ></i>
                                      Notes
                                    </button>
                                  </li>
                                  <li class="nav-item" role="presentation">
                                    <button
                                        class="nav-link fs-15 p-3"
                                        id="pills-econtact"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-econtact-tab"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-econtact-tab"
                                        aria-selected="false"
                                        @click="getEcontacts()"
                                    >
                                      <i
                                          class="
                          ri-alarm-warning-line
                          fs-16
                          p-2
                          bg-soft-primary
                          text-primary
                          rounded-circle
                          align-middle
                          me-2
                        "
                                      ></i>
                                      E. Contacts
                                    </button>
                                  </li>
                                  <li class="nav-item" role="presentation">
                                    <button
                                        class="nav-link fs-15 p-3"
                                        id="pills-payment-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-payment"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-payment"
                                        aria-selected="false"
                                    >
                                      <i
                                          class="
                                                ri-folder-upload-line
                                                fs-16
                                                p-2
                                                bg-soft-primary
                                                text-primary
                                                rounded-circle
                                                align-middle
                                                me-2
                                              "
                                      ></i>
                                      Upload Files
                                    </button>
                                  </li>
                                </ul>
                              </div>

                              <div class="tab-content">
                                <div
                                    class="tab-pane fade show active"
                                    id="pills-pills-notes"
                                    role="tabpanel"
                                    aria-labelledby="pills-notes"
                                >
                                  <div>
                                    <div class="row" id="editNoteOpen">
                                      <notes :dataList="notesData" @onFire="getNotes()" :idNumber="1"> </notes>
                                    </div>
                                  </div>
                                </div>
                                <!-- end tab pane -->

                                <div
                                    class="tab-pane fade"
                                    id="pills-econtact-tab"
                                    role="tabpanel"
                                    aria-labelledby="pills-econtact"
                                >
                                  <econtacts :eContactlist="eContactlist" @eContactData="refreshContacts"></econtacts>
                                </div>
                                <!-- end tab pane -->

                                <div
                                    class="tab-pane fade"
                                    id="pills-payment"
                                    role="tabpanel"
                                    aria-labelledby="pills-payment-tab"
                                >
                                  <div>
                                    <div class="col-12 text-center">
                                      <h1 class="mb-3">Upload Files</h1>
                                      <h6><b>Allowed Files:</b> <p>.jpg, .png, .docx, .xls, .jpeg, .pdf</p></h6>
                                      <h6><b>Max. File Size:</b> <p>5 mb</p></h6>
                                      </div>

                                    <div class="col-md-12">
                                      <form enctype='multipart/form-data'>
                                        <div class="form-group">
                                          <label for="uploadFiles">Select Image</label>
                                          <upload
                                              :restrictions="{
                                                 allowedExtensions: [ '.jpg', '.png', '.docx', '.xls', '.jpeg', '.pdf'],
                                                 maxFileSize: 5000000
                                             }"
                                              :auto-upload="false"
                                              :files="uploadFiles"
                                              @add="onAddFile"
                                              :multiple="true"
                                              :with-credentials="false"
                                              @remove="onRemoveFile"
                                              :save-url="'https://a3j63o3n9.dmbgroup.online/api/comm/uploadFile?id='+this.crmUserID+'&selectedUser='+this.crmSelectedUser+'&isClient='+1"
                                              :remove-url="'https://a3j63o3n9.dmbgroup.online/api/comm/uploadFile?id='+this.crmUserID+'&selectedUser='+this.crmSelectedUser+'&isClient='+1"
                                          />
                                        </div>
                                      </form>
                                      <div class="table-responsive" style="margin-top: 20px;">
                                        <button type="button" class="btn btn-soft-success float-end" @click="getFiles(this.crmSelectedUser)"
                                                style="margin-bottom: 10px;"> Refresh File List </button>
                                        <table class="table align-middle table-nowrap mb-0">
                                          <thead class="table-light">
                                          <tr>
                                            <th scope="col">File Name</th>
                                            <th scope="col">Created On</th>
                                            <th scope="col">Actions</th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                          <tr v-for="(data, index) of this.fileList" :key="index">
                                            <td>{{ data.fileName }}</td>
                                            <td>{{ formatDateCT(data.createdOn) }}</td>
                                            <td>
                                              <ul class="list-inline hstack gap-2 mb-0" >
                                                <li class="list-inline-item" title="Download" @click="downloadFile(data.path)">
                                                  <a class="edit-item-btn">
                                                    <i class="ri-file-download-line align-bottom text-muted"></i>
                                                  </a>
                                                </li>
                                                <li class="list-inline-item" title="Delete">
                                                  <a class="remove-item-btn" href="javascript:void(0);" @click="deleteFile(data.ID)">
                                                    <i class="ri-delete-bin-fill align-bottom text-muted"></i>
                                                  </a>
                                                </li>
                                                <li class="list-inline-item showFile" title="Image Preview">

                                                  <!-- Thumbnails Images -->
                                                  <b-img alt="image Preview" width="100" :src="data.path" data-holder-rendered="true" @click="openModal(data.path)"></b-img>
                                                </li>
                                              </ul>
                                            </td>
                                          </tr>

                                          <div id="myModal" class="modal-preview">
                                            <img :src="previewImageURL" alt="" class="modal-content-preview">
                                            <span class="close" @click="closeModal" style="color: red;font-size: 50px;">&times;</span>
                                          </div>

                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <!-- end tab pane -->
                              </div>
                              <!-- end tab content -->
                            </form>
                          </div>
                          <!-- end card body -->
                        </div>
                        <!-- end card -->
                      </div>
                      <!-- end col -->
                    </div>
                  </div>
                </div>
                <!--end col-->
              </div>
              <!--end row-->
            </div>

            <div class="modal-footer">
              <div class="hstack gap-2 justify-content-end">
                <!-- <button type="button" class="btn btn-info" v-if="canVerifyBank" data-bs-toggle="modal" data-bs-target="#plaidVerifyModal" @click="prepareBankVerify">
                  <i class="ri-shield-check-fill me-1"></i> Verify Bank
                </button> -->
                <button type="button" class="btn btn-light" id="closemodal" data-bs-dismiss="modal">Close </button>
                <button type="submit" class="btn btn-success" id="add-btn" @click="createClient">Save </button>
                <button type="button" class="btn btn-success" id="edit-btn" @click="updateClient">Update </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- Filters Modal -->
    <div id="open-filters" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;" data-bs-focus="false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Filters</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <label for="filterKeyword" class="form-label">Keyword</label>
                <input type="text" id="filterKeyword" name="filterKeyword" class="form-control mb-2" placeholder="Enter Keyword" v-model="data.searchValues.keyword">
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-lg-6">
                <label class="form-label">Source</label>
                <Multiselect
                  v-model="data.searchValues.type"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="false"
                  :create-option="false"
                  :options="sourceOptions"
                  placeholder="All Sources"
                  class="form-control"
                  style="padding: 0px;"
                  autocomplete="off"
                />
              </div>
              <div class="col-lg-6">
                <label class="form-label">Status</label>
                <Multiselect
                  v-model="data.searchValues.status"
                  mode="tags"
                  :close-on-select="false"
                  :searchable="false"
                  :create-option="false"
                  :options="statusOptions"
                  placeholder="All Statuses"
                  class="form-control"
                  style="padding: 0px;"
                  autocomplete="off"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="editLanguage" class="form-label">Language</label>
                <select class="form-select mb-2" aria-label="Language" id="filterLanguage" name="filterLanguage" v-model="data.searchValues.language">
                  <option value="1">English</option>
                  <option value="2">Spanish</option>
                  <option value="3">Both</option>
                </select>
              </div>
              <div class="col-lg-6">
                <label for="editStatus" class="form-label">Search by Notes</label>
                <input type="text" id="filterNotes" name="filterNotes" class="form-control mb-2" placeholder="Enter note" v-model="data.searchValues.noteSearch">
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="filterFromDate" class="form-label"> From date </label>
                <flat-pickr
                    v-model="data.searchValues.fromDate"
                    :config="humanfriendlyConfig"
                    class="form-control flatpickr-input"
                    id="filterFromDate"
                    name="filterFromDate"
                ></flat-pickr>
              </div>
              <div class="col-lg-6">
                <label for="filterToDate" class="form-label"> To Date </label>
                <flat-pickr
                    v-model="data.searchValues.toDate"
                    :config="humanfriendlyConfig"
                    class="form-control flatpickr-input"
                    id="filterToDate"
                    name="filterToDate"
                ></flat-pickr>
              </div>
            </div>
             <div class="row mt-4 mb-4">
               <div class="col-lg-12">
                  <label for="filterAge" class="form-label">Age Range: {{ data.searchValues.age[0] }} - {{ data.searchValues.age[1] }}</label>
                  <div class="px-3 pb-2 pt-4">
                    <Slider v-model="data.searchValues.age" :min="0" :max="100" :step="1" :tooltips="true" />
                  </div>
               </div>
               <div class="col-lg-6 mt-3">
                  <label for="filterDNC" class="form-label">DNC Filter</label>
                  <select class="form-select mb-2" id="filterDNC" v-model="data.searchValues.dncFilter">
                    <option value="exclude">Exclude DNC</option>
                    <option value="all">All (Include DNC)</option>
                    <option value="only">Only DNC</option>
                  </select>
                </div>
            </div>
            <div class="row">
              <div class="col-lg-6">
                <label for="filterDateRange" class="form-label">Time Range</label>
                <select class="form-select mb-2" id="filterDateRange" name="filterDateRange" v-model="data.searchValues.dateRange">
                  <option value="0" selected>...</option>
                  <option value="1">Until 2 year Ago</option>
                  <option value="2">Until 4 year Ago</option>
                  <option value="3">Until 5 year Ago</option>
                  <option value="4">Begin of times</option>
                </select>
              </div>
              <div class="col-lg-6">
                <span v-if="viewUserGroup('SUPER_ADMIN_GROUP')">
                  <label for="filterDateRange" class="form-label">Department</label>
                    <select class="form-select mb-2" aria-label="Department" id="filterDepartment" name="filterDepartment"
                            v-model="data.searchValues.department">
                        <option value="0"> All</option>
                        <option v-for="(department, index) of departmentList"  :key="index"
                                v-bind:value="department.departmentID"> {{ department.name }}
                        </option>
                    </select>
                </span>
              </div>
            </div>
            <div class="col-md-12" v-if="viewUserGroup('SUPER_ADMIN_GROUP') || viewUserGroup('ADMIN_GROUP')">
              <label for="typeahead_id" class="form-label">Find By Agent</label>
              <SimpleTypeahead
                  id="typeahead_id"
                  placeholder="Type your agent search..."
                  :items="itemsSearch"
                  :minInputLength="3"
                  :class="'form-control mb-2'"
                  @onInput="searchAgents"
                  @selectItem="selectItemEventHandler"
              >
              </SimpleTypeahead>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="updateClientList()">Search</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <!-- Notes Modal -->
    <div id="open-notes" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <notes :key="this.crmSelectedUser" :dataList="notesData" @onFire="getNotes()" :idNumber="2"></notes>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <!-- Messages Modal -->
    <div id="open-messages" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog">
        <div class="modal-content">
          <messages :messageList="messagesData" @onFire="getSMS()" :idNumber="1"></messages>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <!-- Move to Prospect Modal -->
    <div id="changeStatus" class="modal fade" tabindex="-1" aria-labelledby="myModalLabel" aria-hidden="true" style="display: none;">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content ">
          <div class="modal-header">
            <h5 class="modal-title" id="myModalLabel">Move client to prospect list</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <label for="moveStatus" class="form-label">Status</label>
                <select class="form-select mb-2" aria-label="Status" id="moveStatus">
                  <option value="0">All</option>
                  <option v-for="(status, statusIndex) of prospectStatusList" :key="statusIndex" v-bind:value="status.statusID">{{ status.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" id="closeMove" data-bs-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" @click="moveClient()">Move</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->

    <!-- Upload Agents Modal -->
    <!-- Upload Clients Modal -->
    <b-modal id="uploadLeads" title="Upload Clients" class="v-modal-custom" fullscreen @hidden="resetUploadWizard" style="z-index: 995;">
      <!-- Loading Overlay -->
      <div v-if="isLoading" class="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" 
           style="background-color: rgba(255, 255, 255, 0.95); z-index: 9999;">
        <div class="text-center">
          <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h5 class="text-primary">Importing Clients...</h5>
          <p class="text-muted">Please wait while we process your data</p>
        </div>
      </div>
      
      <div class="row">
        <div class="col-lg-12">
          
          <!-- Step Indicator -->
          <div class="card mb-3">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center" :class="{'text-primary fw-bold': uploadStep === 1}">
                  <div class="rounded-circle d-flex align-items-center justify-content-center me-2" 
                       :class="uploadStep >= 1 ? 'bg-primary text-white' : 'bg-light'" 
                       style="width: 32px; height: 32px;">1</div>
                  <span>Upload File</span>
                </div>
                <div class="flex-grow-1 mx-3" style="height: 2px; background: #e9ecef;"></div>
                <div class="d-flex align-items-center" :class="{'text-primary fw-bold': uploadStep === 2}">
                  <div class="rounded-circle d-flex align-items-center justify-content-center me-2" 
                       :class="uploadStep >= 2 ? 'bg-primary text-white' : 'bg-light'" 
                       style="width: 32px; height: 32px;">2</div>
                  <span>Map Columns</span>
                </div>
                <div class="flex-grow-1 mx-3" style="height: 2px; background: #e9ecef;"></div>
                <div class="d-flex align-items-center" :class="{'text-primary fw-bold': uploadStep === 3}">
                  <div class="rounded-circle d-flex align-items-center justify-content-center me-2" 
                       :class="uploadStep >= 3 ? 'bg-primary text-white' : 'bg-light'" 
                       style="width: 32px; height: 32px;">3</div>
                  <span>Review & Import</span>
                </div>
              </div>
            </div>
          </div>

          <!-- STEP 1: Upload File -->
          <div v-if="uploadStep === 1" class="card">
            <div class="card-body">
              <h5 class="card-title mb-3">Step 1: Upload Your File</h5>
              <p class="text-muted">Supported formats: CSV, Excel (.xlsx, .xls)</p>
              
              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Upload Instructions</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>We accept <strong>CSV, Excel (.xlsx, .xls)</strong> files</li>
                  <li>Your file <strong>must have column headers</strong> in the first row</li>
                  <li>In the next step, you'll <strong>map each column</strong> from your file to our system fields</li>
                  <li><strong>Important:</strong> Only mapped columns will be imported - unmapped data will be skipped</li>
                  <li><em>Optional:</em> Download a template below to see the recommended format</li>
                </ul>
              </div>

              <!-- File Input -->
              <div class="mb-4">
                <input class="form-control form-control-lg border-primary border-2 shadow-sm" style="background-color: #f0f4f8; cursor: pointer;" id="listFile" type="file"
                       accept=".csv,.xlsx,.xls" @change="selectedFile"/>
              </div>

              <!-- File Info -->
              <div v-if="uploadedFile" class="alert alert-success">
                <i class="ri-file-check-line me-2"></i>
                <strong>{{ uploadedFile.name }}</strong> 
                ({{ (uploadedFile.size / 1024).toFixed(2) }} KB)
                - {{ parsedData.length }} rows detected
              </div>

              <!-- Template Download -->
              <div class="mt-4">
                <h6>Need a template?</h6>
                <a href="https://dmbgroup.online/wp-content/uploads/2024/08/plantilla-para-clientes-o-prospectos-DMB-INSURANCE-CRM.csv" 
                   class="btn btn-sm btn-outline-success">
                  <i class="ri-download-line me-1"></i> Download CSV Template
                </a>
              </div>
            </div>
          </div>

          <!-- STEP 2: Map Columns -->
          <div v-if="uploadStep === 2" class="card">
            <div class="card-body">
              <h5 class="card-title mb-3">Step 2: Map Your Columns</h5>
              <p class="text-muted">Match your file columns to our system fields. Required fields are marked with *</p>

              <!-- Mobile Rotate Notice -->
              <div class="alert alert-danger d-block d-md-none mb-3">
                <i class="ri-smartphone-line me-1"></i> <strong>Tip:</strong> For a better experience, rotate your phone horizontally to see all columns clearly.
              </div>

              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Mapping Instructions</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>We've automatically detected and mapped some columns for you - <strong>please verify they are correct</strong></li>
                  <li><strong>You must select a field</strong> for each column you want to import using the dropdowns below</li>
                  <li>Fields marked with <strong>*</strong> are required (First Name or Full Name, Last Name, and Phone)</li>
                  <li>Columns set to "-- Skip this column --" will <strong>not be imported</strong></li>
                  <li>The "Sample Data" column shows the first row to help you verify the mapping</li>
                </ul>
              </div>

              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th class="text-nowrap">Your Column</th>
                      <th class="text-nowrap">Sample Data</th>
                      <th style="min-width: 200px;">Map To Field</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(header, index) in parsedHeaders" :key="index">
                      <td class="text-nowrap"><strong>{{ header }}</strong></td>
                      <td class="text-muted text-nowrap" style="max-width: 200px; overflow: hidden; text-overflow: ellipsis;">{{ parsedData[0] ? parsedData[0][header] : '' }}</td>
                      <td>
                        <select class="form-select" 
                                :value="getMappedFieldForColumn(header)"
                                @change="updateColumnMapping(header, $event.target.value)">
                          <option value="">-- Skip this column --</option>
                          <option v-for="field in systemFields" :key="field.key" :value="field.key">
                            {{ field.label }}
                          </option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- STEP 3: Review & Import -->
          <div v-if="uploadStep === 3" class="card">
            <div class="card-body">
              <h5 class="card-title mb-3">Step 3: Review & Import</h5>
              <p class="text-muted">Review the mapped data before importing</p>
              
              <!-- Instructions Alert -->
              <div class="alert alert-info mb-3">
                <h6 class="alert-heading"><i class="ri-information-line me-1"></i> Final Steps</h6>
                <ul class="mb-0" style="font-size: 0.9em;">
                  <li>Review the preview below to ensure data is mapped correctly</li>
                  <li>Fill in all required fields (Agent, Status, Language, Source)</li>
                  <li>Click "Process & Upload" to begin importing your data</li>
                  <li>Large files will be processed in chunks - please wait for completion</li>
                </ul>
              </div>

              <!-- Import Settings -->
              <div class="row mb-4">
                <div class="col-lg-3">
                  <label for="uploadLanguage" class="form-label">Language *</label>
                  <select class="form-select" id="uploadLanguage" name="uploadLanguage">
                    <option value="">...</option>
                    <option value="1">English</option>
                    <option value="2">Spanish</option>
                    <option value="3">Take from list</option>
                  </select>
                </div>
                <div class="col-lg-3">
                  <label for="uploadStatus" class="form-label">Status *</label>
                  <select class="form-select" id="uploadStatus" name="uploadStatus">
                    <option value="">...</option>
                    <option v-for="(status, statusIndex) of statusList" :key="statusIndex"
                            v-bind:value="status.statusID">{{ status.name }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-3">
                  <label for="uploadType" class="form-label">Source *</label>
                  <select class="form-select" id="uploadType" name="uploadType">
                    <option value="">...</option>
                    <option v-for="(type, typeIndex) of typeList" :key="typeIndex" v-bind:value="type.name">
                      {{ type.name }}
                    </option>
                  </select>
                </div>
              </div>

              <!-- Data Preview -->
              <h6>Data Preview (first 5 rows)</h6>
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead class="table-light">
                    <tr>
                      <th>#</th>
                      <th v-for="(fieldKey, index) in getTransformedFieldKeys()" 
                          :key="index">
                        {{ getFieldLabel(fieldKey) }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, rowIndex) in getMappedPreviewData()" :key="rowIndex">
                      <td>{{ rowIndex + 1 }}</td>
                      <td v-for="(value, key) in row" :key="key">{{ value }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="alert alert-info mt-3">
                <i class="ri-information-line me-2"></i>
                Ready to import <strong>{{ parsedData.length }}</strong> clients
              </div>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div class="d-flex justify-content-between mt-4">
            <button type="button" class="btn btn-light" @click="previousStep" 
                    v-if="uploadStep > 1">
              <i class="ri-arrow-left-line me-1"></i> Previous
            </button>
            <div></div>
            <button type="button" class="btn btn-primary" @click="nextStep" 
                    v-if="uploadStep < 3">
              Next <i class="ri-arrow-right-line ms-1"></i>
            </button>
            <button type="button" class="btn btn-success" @click="processAndUpload" 
                    v-if="uploadStep === 3">
              <i class="ri-upload-cloud-line me-1"></i> Import Clients
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- ===== Full-screen Map Modal ===== -->
    <teleport to="body" v-if="showMapModal">
      <div class="map-modal-overlay" @click.self="closeMap">
        <div class="map-modal-container">
          <!-- Header -->
          <div class="map-modal-header">
            <div class="d-flex align-items-center gap-3">
              <i class="ri-map-pin-line fs-4 text-info"></i>
              <h5 class="mb-0">
                Map — <strong>{{ mapMarkers.length }}</strong> of {{ selectedClients.length }} clients shown
              </h5>
              <span v-if="selectedMapMarker" class="badge bg-info">
                {{ selectedMapMarker.title }}
              </span>
            </div>
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="closeMap">
              <i class="ri-close-line"></i> Close
            </button>
          </div>

          <!-- Loading spinner -->
          <div v-if="mapIsLoading" class="map-modal-loading">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2 text-muted">Loading map pins...</p>
          </div>

          <!-- Map -->
          <div v-else class="map-modal-body">
            <GoogleMap
              api-key="AIzaSyBJXnhtk3_2A9SN4ExKh0m9UBlEJk3hsCU"
              :center="mapMarkers.length > 0 ? { lat: mapMarkers[0].lat, lng: mapMarkers[0].lng } : { lat: 29.7829, lng: -95.6693 }"
              :zoom="mapMarkers.length === 1 ? 14 : 8"
              style="width: 100%; height: 100%;"
            >
              <MarkerCluster>
                <Marker
                  v-for="m in mapMarkers"
                  :key="m.ID"
                  :options="{
                    position: { lat: parseFloat(m.lat), lng: parseFloat(m.lng) },
                    title: m.title,
                    icon: getMarkerIcon(m.markerColor)
                  }"
                  @click="selectedMapMarker = m"
                />
              </MarkerCluster>

              <InfoWindow
                v-if="selectedMapMarker"
                :options="{ position: { lat: selectedMapMarker.lat, lng: selectedMapMarker.lng }, disableAutoPan: true }"
                @closeclick="selectedMapMarker = null"
              >
                <div id="content">
                  <h1 id="firstHeading" class="firstHeading">{{ selectedMapMarker.title }}</h1>
                  <div id="bodyContent">
                    <p>
                      <b>Address:</b> {{ selectedMapMarker.address }}
                      <br>
                      <b>Phone:</b>
                      <a :href="'tel:'+selectedMapMarker.phoneNumber" style="line-height:1.5;color:#7f8c8d;">
                        {{ selectedMapMarker.phoneNumber }}
                      </a>
                      <br>
                      <b>Last Visit:</b> {{ selectedMapMarker.lastVisitDate ? formatDate(selectedMapMarker.lastVisitDate, 'MMM DD, YYYY') : 'Never' }}
                      <br>
                      <a
                        :href="'https://maps.google.com/?q='+encodeURIComponent(selectedMapMarker.address)"
                        target="_blank"
                        style="line-height:1.5;color:#25a0e2;"
                      >
                        View On Google Maps
                      </a>
                    </p>
                    <div class="info-actions">
                      <a class="btn btn-dark btn-sm" :href="'tel:'+selectedMapMarker.phoneNumber">
                        Call
                      </a>
                      <button
                        class="btn btn-dark btn-sm"
                        @click="getClientInfo(selectedMapMarker.ID)"
                        data-bs-toggle="modal"
                        data-bs-target="#agentModal"
                      >
                        View
                      </button>
                      <!-- Mark Visited removed to force users into the form -->
                    </div>
                  </div>
                </div>
              </InfoWindow>

            </GoogleMap>
          </div>
        </div>
      </div>
    </teleport>

    <!-- <PlaidAuthVerifyModal ref="plaidVerifyModal" /> -->
    <div class="modal fade" id="transferModal" tabindex="-1" aria-labelledby="transferModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="transferModalLabel">Transfer {{ selectedClients.length }} record(s)</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-md-12">
                <label for="transfer_typeahead_id" class="form-label">Search Agent by Name or Email</label>
                <SimpleTypeahead
                    id="transfer_typeahead_id"
                    placeholder="Type at least 3 characters..."
                    :items="itemsSearch"
                    :minInputLength="3"
                    :class="'form-control'"
                    @onInput="searchAgents"
                    @selectItem="selectTransferAgentEventHandler"
                >
                </SimpleTypeahead>
              </div>
            </div>
            <h6>Clients to be transferred:</h6>
            <div class="table-responsive" style="max-height: 300px; overflow-y: auto;">
              <table class="table table-bordered table-sm mb-0">
                <thead style="position: sticky; top: 0; background-color: #2b3136; z-index: 1;">
                  <tr>
                    <th>Full Name</th>
                    <th>Status</th>
                    <th>Source</th>
                    <th>Phone Number</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="c in selectedClientsData" :key="c.ID">
                    <td>{{ c.firstName }} {{ c.lastName }}</td>
                    <td>{{ c.statusName || 'N/A' }}</td>
                    <td>{{ c.sourceName || c.leadType || 'N/A' }}</td>
                    <td>{{ c.phoneNumber || 'N/A' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="executeBulkTransfer(null, 0)">Transfer</button>
          </div>
        </div>
      </div>
    </div>
    <TrafficLightLegend />
    </Layout>

    <!-- Floating Selection Widget -->
    <div v-if="selectedClients.length > 0" class="selection-widget" style="position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%); background: #2b3136; border: 1px solid #40464c; border-radius: 50px; padding: 10px 20px; display: flex; align-items: center; gap: 15px; box-shadow: 0 4px 15px rgba(0,0,0,0.5); z-index: 1050;">
      <div style="display: flex; align-items: center; gap: 8px; color: #fff;">
        <i class="ri-clipboard-line text-primary fs-5"></i> 
        <span style="font-weight: 500;">Lista CallUp: {{ selectedClients.length }}</span>
      </div>
      <button class="btn btn-sm btn-primary rounded-pill px-3" @click="selectAllCurrentPage">Seleccionar página</button>
      <button class="btn btn-sm btn-dark rounded-pill border px-3" @click="clearSelection">Deseleccionar</button>
      <button class="btn btn-sm btn-link text-white p-0 ms-2" @click="clearSelection"><i class="ri-close-line fs-5"></i></button>
    </div>
</template>

<style>
#content {
  margin: 0;
  padding: 14px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
  font-family: Arial, sans-serif;
  min-width: 280px;
}

.firstHeading {
  font-size: 1.25em;
  font-weight: 700;
  margin: 0 0 10px 0;
  text-align: center;
  color: #2c3e50;
}

#bodyContent {
  line-height: 1.5;
  color: #7f8c8d;
}

#bodyContent b {
  color: #2c3e50;
}

.info-actions{
  display:flex;
  justify-content:center;
  gap:10px;
  margin-top:12px;
}

/* Slider Custom Styles */
.slider-tooltip {
  font-size: 11px !important;
  padding: 2px 5px !important;
  min-width: 20px !important;
  background: #0ab39c !important; /* Matching the theme color */
  border: #0ab39c !important;
}

.slider-handle:focus {
  box-shadow: 0 0 0 3px rgba(10, 179, 156, 0.3) !important;
}
</style>
